import React, { useState, useEffect, useCallback } from 'react';
import {
  FiClock,
  FiDownload,
  FiMaximize,
  FiCalendar,
  FiTrash2,
  FiAlertTriangle,
  FiCheckCircle,
  FiX,
  FiSearch,
  FiBell,
  FiUserPlus,
  FiChevronLeft,
  FiChevronRight,
  FiFileText,
  FiUserCheck,
  FiUserX,
  FiRefreshCw,
  FiChevronDown,
  FiUsers,
} from 'react-icons/fi';
import API from 'shared/api';
import { empresaUrl } from 'shared/config';
import socket from 'shared/socket';
import { useAuth } from 'shared/context/AuthContext';
import useWindowSize from 'shared/hooks/useWindowSize';
import { toDataURL } from 'qrcode';
import AsistenciaModal from '../components/Asistencia/AsistenciaModal';

function isDark() {
  try {
    return document.documentElement.getAttribute('data-dark') === 'true';
  } catch {
    return false;
  }
}

const S_COLORS = {
  entrada: '#16a34a',
  salida: '#dc2626',
  llegada_tarde: '#ea580c',
  salida_temprana: '#f59e0b',
  gap_entrada: '#dc2626',
  gap_salida: '#dc2626',
};
const RETRASO_LABELS = {
  llegada_tarde: 'Llegada tarde',
  salida_temprana: 'Salida temprana',
  gap_entrada: 'Falta salida previa',
  gap_salida: 'Falta entrada previa',
};

const BRAND_BLUE = '#0B1A4A';
const ACCENT_BLUE = '#1a73e8';
const BG_PAGE = 'var(--agx-bg)';

export default function Asistencia() {
  const { usuario, isAdmin, isSupervisor, tienePermiso } = useAuth();
  const { width } = useWindowSize();
  const isMobile = width < 768;

  const [tab, setTab] = useState('mi-asistencia');
  const [miEstado, setMiEstado] = useState(null);
  const [misRegistros, setMisRegistros] = useState([]);
  const [showAsistenciaModal, setShowAsistenciaModal] = useState(false);

  const [usuariosEstado, setUsuariosEstado] = useState([]);
  const [userSearch, setUserSearch] = useState('');
  const [userDetail, setUserDetail] = useState(null);
  const [userDetailRegs, setUserDetailRegs] = useState([]);
  const [userStats, setUserStats] = useState(null);
  const [manualOpen, setManualOpen] = useState(false);
  const [manualTipo, setManualTipo] = useState('entrada');
  const [manualSede, setManualSede] = useState('');
  const [manualNotas, setManualNotas] = useState('');
  const [manualHora, setManualHora] = useState('');

  const [registros, setRegistros] = useState([]);
  const [regMore, setRegMore] = useState(false);
  const [regUltimo, setRegUltimo] = useState(null);
  const [regUltimoHora, setRegUltimoHora] = useState(null);
  const [reportYear, setReportYear] = useState(new Date().getFullYear());
  const [reportMonth, setReportMonth] = useState(null);
  const [resumenMensual, setResumenMensual] = useState(null);
  const [detalleDia, setDetalleDia] = useState(null);
  const [detalleFecha, setDetalleFecha] = useState(null);
  const [detalleAvisos, setDetalleAvisos] = useState([]);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [horarios, setHorarios] = useState([]);
  const hoy = new Date();
  const [filtros, setFiltros] = useState({
    fecha_desde: `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2, '0')}-01`,
    fecha_hasta: '',
    solo_alertas: false,
  });
  const [misHorasMes, setMisHorasMes] = useState(null);

  const [qrGenOpen, setQrGenOpen] = useState(false);
  const [qrGenSede, setQrGenSede] = useState('');
  const [qrGenResult, setQrGenResult] = useState(null);
  const [qrGenError, setQrGenError] = useState(null);
  const [qrGenLoading, setQrGenLoading] = useState(false);
  const [qrImageUrl, setQrImageUrl] = useState(null);
  const [qrAll, setQrAll] = useState([]);
  const [qrLoading, setQrLoading] = useState(false);
  const [qrImageMap, setQrImageMap] = useState({});
  const [qrRegenConfirm, setQrRegenConfirm] = useState(null);
  const [sedes, setSedes] = useState([]);
  const [qrCopyToken, setQrCopyToken] = useState(null);

  const [schedOpen, setSchedOpen] = useState(false);
  const [schedEdit, setSchedEdit] = useState(null);
  const [filtrosOpen, setFiltrosOpen] = useState(false);
  const [usuarioResumen, setUsuarioResumen] = useState(null);
  const [userDetailMonth, setUserDetailMonth] = useState(new Date().getMonth() + 1);
  const [userDetailYear, setUserDetailYear] = useState(new Date().getFullYear());
  const [pdfUrlUsuario, setPdfUrlUsuario] = useState(null);
  const [pdfLoadingUsuario, setPdfLoadingUsuario] = useState(false);

  const [misAvisos, setMisAvisos] = useState([]);
  const [avisoOpen, setAvisoOpen] = useState(false);
  const [avisoFecha, setAvisoFecha] = useState(new Date().toISOString().slice(0, 10));
  const [avisoTipo, setAvisoTipo] = useState('ausencia');
  const [avisoMotivo, setAvisoMotivo] = useState('');
  const [avisoError, setAvisoError] = useState(null);
  const [avisoGuardando, setAvisoGuardando] = useState(false);

  const [editRegistro, setEditRegistro] = useState(null);
  const [editTipo, setEditTipo] = useState('entrada');
  const [editHora, setEditHora] = useState('');
  const [editSede, setEditSede] = useState('');
  const [editNotas, setEditNotas] = useState('');
  const [editSaving, setEditSaving] = useState(false);

  const [nuevoOpen, setNuevoOpen] = useState(false);
  const [nuevoUsuario, setNuevoUsuario] = useState('');
  const [nuevoTipo, setNuevoTipo] = useState('entrada');
  const [nuevoHora, setNuevoHora] = useState('');
  const [nuevoSede, setNuevoSede] = useState('');
  const [nuevoNotas, setNuevoNotas] = useState('');
  const [nuevoSaving, setNuevoSaving] = useState(false);

  const [regFiltroUsuario, setRegFiltroUsuario] = useState('');
  const [regFiltroSede, setRegFiltroSede] = useState('');

  const permVer = isAdmin() || isSupervisor() || tienePermiso('asistencia.ver');
  const permGest = isAdmin() || tienePermiso('asistencia.gestionar');
  const permCorregir = isAdmin() || tienePermiso('asistencia.corregir');

  const ST = {
    page: {
      padding: isMobile ? '12px' : '24px',
      maxWidth: '1240px',
      margin: '0 auto',
      fontFamily: "'Inter', system-ui, sans-serif",
      background: BG_PAGE,
      minHeight: '100vh',
    },
    h1: {
      fontSize: isMobile ? '22px' : '26px',
      fontWeight: 700,
      color: 'var(--agx-text)',
      margin: '0 0 2px',
      letterSpacing: '-0.3px',
    },
    sub: { fontSize: '13px', color: 'var(--agx-muted)' },
    tabsContainer: {
      display: 'flex',
      gap: '4px',
      marginBottom: '24px',
      borderBottom: '2px solid var(--agx-border)',
      overflowX: 'auto',
      overflowY: 'hidden',
      WebkitOverflowScrolling: 'touch',
      scrollbarWidth: 'none',
    },
    tab: (act) => ({
      padding: '10px 18px',
      fontSize: '13px',
      fontWeight: 600,
      cursor: 'pointer',
      border: 'none',
      background: act ? 'var(--agx-surface)' : 'transparent',
      fontFamily: 'inherit',
      color: act ? ACCENT_BLUE : 'var(--agx-muted)',
      borderBottom: act ? '2px solid ' + ACCENT_BLUE : '2px solid transparent',
      marginBottom: '-2px',
      transition: 'all 0.15s',
      whiteSpace: 'nowrap',
      borderRadius: '6px 6px 0 0',
    }),
    card: {
      background: 'var(--agx-surface)',
      borderRadius: '16px',
      padding: isMobile ? '16px' : '24px',
      boxShadow: '0 1px 3px rgba(0,0,0,0.04), 0 1px 2px rgba(0,0,0,0.03)',
      border: '1px solid var(--agx-border)',
      overflowX: 'auto',
      transition: 'box-shadow 0.2s',
    },
    cardHover: {
      background: 'var(--agx-surface)',
      borderRadius: '16px',
      padding: isMobile ? '16px' : '24px',
      boxShadow: '0 1px 3px rgba(0,0,0,0.04), 0 1px 2px rgba(0,0,0,0.03)',
      border: '1px solid var(--agx-border)',
      overflowX: 'auto',
      transition: 'all 0.2s',
    },
    table: { width: '100%', borderCollapse: 'collapse', fontSize: '13px', minWidth: '600px' },
    th: {
      textAlign: 'left',
      padding: '10px 14px',
      borderBottom: '2px solid var(--agx-border)',
      fontSize: '11px',
      fontWeight: 700,
      color: 'var(--agx-muted)',
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
      background: 'var(--agx-bg2)',
    },
    td: {
      padding: '10px 14px',
      borderBottom: '1px solid var(--agx-border)',
      color: 'var(--agx-muted)',
      fontSize: '13px',
    },
    trEven: { background: 'var(--agx-bg2)' },
    badge: (color) => ({
      display: 'inline-block',
      padding: '3px 10px',
      borderRadius: '10px',
      fontSize: '11px',
      fontWeight: 600,
      background: color + '15',
      color,
      letterSpacing: '0.2px',
    }),
    alertaBadge: (tipo) => ({
      display: 'inline-flex',
      alignItems: 'center',
      gap: '4px',
      padding: '3px 10px',
      borderRadius: '10px',
      fontSize: '11px',
      fontWeight: 600,
      background: (S_COLORS[tipo] || '#94a3b8') + '15',
      color: S_COLORS[tipo] || 'var(--agx-muted)',
    }),
    btn: (color) => ({
      display: 'inline-flex',
      alignItems: 'center',
      gap: '7px',
      padding: '9px 18px',
      borderRadius: '10px',
      border: 'none',
      fontSize: '13px',
      fontWeight: 600,
      cursor: 'pointer',
      fontFamily: 'inherit',
      background: color || ACCENT_BLUE,
      color: 'var(--agx-surface)',
      transition: 'all 0.15s',
      boxShadow: '0 1px 2px rgba(0,0,0,0.06)',
    }),
    btnOutline: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '7px',
      padding: '9px 18px',
      borderRadius: '10px',
      border: '1.5px solid var(--agx-skeleton)',
      fontSize: '13px',
      fontWeight: 600,
      cursor: 'pointer',
      fontFamily: 'inherit',
      background: 'var(--agx-surface)',
      color: 'var(--agx-muted)',
      transition: 'all 0.15s',
    },
    btnRed: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '7px',
      padding: '9px 18px',
      borderRadius: '10px',
      border: 'none',
      fontSize: '13px',
      fontWeight: 600,
      cursor: 'pointer',
      fontFamily: 'inherit',
      background: '#dc2626',
      color: 'var(--agx-surface)',
      transition: 'all 0.15s',
      boxShadow: '0 1px 2px rgba(0,0,0,0.06)',
    },
    input: {
      padding: '9px 12px',
      borderRadius: '8px',
      border: '1.5px solid var(--agx-skeleton)',
      fontSize: '13px',
      fontFamily: 'inherit',
      width: '100%',
      maxWidth: '200px',
      boxSizing: 'border-box',
      background: 'var(--agx-surface)',
    },
    searchInput: {
      flex: 1,
      padding: '10px 14px 10px 38px',
      borderRadius: '10px',
      border: '1.5px solid var(--agx-skeleton)',
      fontSize: '13px',
      fontFamily: 'inherit',
      boxSizing: 'border-box',
      background: 'var(--agx-surface)',
    },
    flexRow: {
      display: 'flex',
      gap: '10px',
      flexWrap: 'wrap',
      alignItems: 'center',
      marginBottom: '16px',
    },
    statCard: (color) => ({
      background: 'var(--agx-surface)',
      borderRadius: '14px',
      padding: '16px 20px',
      display: 'flex',
      alignItems: 'center',
      gap: '14px',
      border: '1px solid var(--agx-border)',
      boxShadow: '0 1px 2px rgba(0,0,0,0.03)',
      borderLeft: '4px solid ' + color,
      minWidth: '160px',
    }),
    userGrid: {
      display: 'grid',
      gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fill, minmax(320px, 1fr))',
      gap: '10px',
    },
    userCard: (activo) => ({
      background: 'var(--agx-surface)',
      borderRadius: '14px',
      padding: '18px',
      border: '1px solid var(--agx-border)',
      boxShadow: '0 1px 2px rgba(0,0,0,0.03)',
      cursor: 'pointer',
      transition: 'all 0.2s',
      display: 'flex',
      alignItems: 'center',
      gap: '14px',
    }),
    userDot: (activo) => ({
      width: '12px',
      height: '12px',
      borderRadius: '50%',
      background: activo ? '#16a34a' : '#94a3b8',
      flexShrink: 0,
      boxShadow: activo ? '0 0 0 3px rgba(22,163,74,0.15)' : 'none',
    }),
    modal: {
      position: 'fixed',
      inset: 0,
      background: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      padding: '20px',
      animation: 'fadein 0.15s ease',
    },
    modalContent: (wide) => ({
      background: 'var(--agx-surface)',
      borderRadius: '20px',
      padding: isMobile ? '20px' : '28px',
      width: '100%',
      maxWidth: wide ? '640px' : '480px',
      maxHeight: '90vh',
      overflow: 'auto',
      boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
    }),
    modalWide: {
      background: 'var(--agx-surface)',
      borderRadius: '20px',
      padding: isMobile ? '20px' : '28px',
      width: '100%',
      maxWidth: '680px',
      maxHeight: '90vh',
      overflow: 'auto',
      boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
    },
    confirmBox: {
      background: isDark() ? '#064e3b' : '#f0fdf4',
      borderRadius: '14px',
      padding: '24px',
      textAlign: 'center',
      border: '1px solid #bbf7d0',
      marginBottom: '16px',
    },
    sectionTitle: {
      fontSize: '14px',
      fontWeight: 700,
      color: 'var(--agx-text)',
      marginBottom: '12px',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    emptyState: {
      textAlign: 'center',
      color: 'var(--agx-faint)',
      fontSize: '13px',
      padding: '24px',
    },
    monthCard: (active) => ({
      padding: isMobile ? '16px' : '20px',
      borderRadius: '14px',
      border: active ? '2px solid ' + ACCENT_BLUE : '1px solid var(--agx-border)',
      background: active ? (isDark() ? '#1e3a5f' : '#eff6ff') : 'var(--agx-surface)',
      cursor: 'pointer',
      textAlign: 'center',
      fontFamily: 'inherit',
      transition: 'all 0.15s',
      boxShadow: active ? '0 2px 8px rgba(26,115,232,0.12)' : '0 1px 2px rgba(0,0,0,0.03)',
    }),
    calendarCell: (hasData) => ({
      padding: isMobile ? '6px 2px' : '8px 4px',
      borderRadius: '10px',
      border: '1px solid var(--agx-border)',
      background: hasData ? (isDark() ? '#064e3b' : '#f0fdf4') : 'var(--agx-bg2)',
      cursor: hasData ? 'pointer' : 'default',
      textAlign: 'center',
      fontFamily: 'inherit',
      minHeight: isMobile ? '48px' : '58px',
      transition: 'all 0.15s',
    }),
    qrCard: {
      background: 'var(--agx-surface)',
      borderRadius: '16px',
      border: '1px solid var(--agx-border)',
      padding: isMobile ? '20px' : '24px',
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '14px',
      boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
      transition: 'all 0.2s',
    },
  };

  useEffect(() => {
    if (qrGenResult?.token) {
      const slug = localStorage.getItem('agorax_empresa_slug') || '';
      const data = `${empresaUrl(slug)}/asistencia?token=${qrGenResult.token}`;
      toDataURL(data, { width: 280, margin: 2, color: { dark: BRAND_BLUE, light: '#FFFFFF' } })
        .then((url) => setQrImageUrl(url))
        .catch(() => setQrImageUrl(null));
    } else {
      setQrImageUrl(null);
    }
  }, [qrGenResult]);

  const loadMiEstado = useCallback(async () => {
    try {
      const r = await API.get('/asistencia/mi-estado');
      if (r.data.status === 'success') setMiEstado(r.data.data);
    } catch (e) {}
  }, []);
  const loadMisRegistros = useCallback(async () => {
    try {
      const r = await API.get('/asistencia/mis-registros', { params: { limite: 30 } });
      if (r.data.status === 'success') setMisRegistros(r.data.data);
    } catch (e) {}
  }, []);

  const loadMisAvisos = useCallback(async () => {
    try {
      const r = await API.get('/asistencia/mis-avisos');
      if (r.data.status === 'success') setMisAvisos(r.data.data);
    } catch (e) {}
  }, []);

  const loadMisHorasMes = useCallback(async () => {
    const n = new Date();
    const pad = (v) => String(v).padStart(2, '0');
    const horaCliente = `${n.getFullYear()}-${pad(n.getMonth() + 1)}-${pad(n.getDate())}T${pad(n.getHours())}:${pad(n.getMinutes())}:${pad(n.getSeconds())}`;
    try {
      const r = await API.get('/asistencia/mis-horas-mes', {
        params: { year: n.getFullYear(), month: n.getMonth() + 1, hora_cliente: horaCliente },
      });
      if (r.data.status === 'success') setMisHorasMes(r.data.data);
    } catch (e) {}
  }, []);

  useEffect(() => {
    loadMiEstado();
    loadMisRegistros();
    loadMisHorasMes();
    loadMisAvisos();
  }, [loadMiEstado, loadMisRegistros, loadMisHorasMes, loadMisAvisos]);

  const loadUsuariosEstado = useCallback(async () => {
    if (!permVer) return;
    try {
      const r = await API.get('/asistencia/usuarios-estado');
      if (r.data.status === 'success') setUsuariosEstado(r.data.data);
    } catch (e) {}
  }, [permVer]);

  const loadRegistros = useCallback(
    async (reset = true) => {
      if (!permVer) return;
      try {
        const params = { limite: 50 };
        if (!reset && regUltimo && regUltimoHora) {
          params.ultimo_id = regUltimo;
          params.ultimo_hora = regUltimoHora;
        }
        if (filtros.fecha_desde) params.fecha_desde = filtros.fecha_desde;
        if (filtros.fecha_hasta) params.fecha_hasta = filtros.fecha_hasta;
        if (filtros.solo_alertas) params.solo_alertas = true;
        if (regFiltroUsuario) params.usuario_cedula = regFiltroUsuario;
        if (regFiltroSede) params.sede_codigo = regFiltroSede;
        const r = await API.get('/asistencia/registros', { params });
        if (r.data.status === 'success') {
          if (reset) {
            setRegistros(r.data.data);
          } else {
            setRegistros((prev) => [...prev, ...r.data.data]);
          }
          setRegMore(r.data.pagination?.has_more || false);
          setRegUltimo(r.data.pagination?.ultimo_id || null);
          setRegUltimoHora(r.data.pagination?.ultimo_hora || null);
        }
      } catch (e) {}
    },
    [permVer, regUltimo, regUltimoHora, filtros, regFiltroUsuario, regFiltroSede]
  );

  const loadHorarios = useCallback(async () => {
    if (!permGest) return;
    try {
      const r = await API.get('/asistencia/horarios');
      if (r.data.status === 'success') setHorarios(r.data.data);
    } catch (e) {}
  }, [permGest]);

  const loadSedes = useCallback(async () => {
    try {
      const r = await API.get('/sedes/listar');
      if (r.data?.status === 'success') setSedes(r.data.data);
      else console.error('[loadSedes] Respuesta inesperada:', r.data);
    } catch (e) {
      console.error('[loadSedes] Error:', e);
    }
  }, []);

  useEffect(() => {
    if (tab === 'usuarios') loadUsuariosEstado();
    if (tab === 'registros') {
      setRegistros([]);
      setRegUltimo(null);
      setRegUltimoHora(null);
      loadRegistros(true);
      loadSedes();
      loadUsuariosEstado();
    }
    if (tab === 'horarios') loadHorarios();
    if (tab === 'qrs') loadQrsPorSede();
  }, [tab]); // eslint-disable-line

  const loadResumenMensual = async (year, month) => {
    try {
      const r = await API.get('/asistencia/resumen-mensual', { params: { year, month } });
      if (r.data.status === 'success') setResumenMensual(r.data.data);
    } catch (e) {}
  };

  const loadDetalleDia = async (fecha) => {
    try {
      const r = await API.get('/asistencia/reporte-diario', { params: { fecha } });
      if (r.data.status === 'success') {
        setDetalleDia(r.data.data);
        setDetalleFecha(fecha);
        setDetalleAvisos(r.data.avisos || []);
      }
    } catch (e) {}
  };

  const handleExportPDF = async () => {
    if (!reportMonth) return;
    setPdfLoading(true);
    try {
      const r = await API.get('/asistencia/exportar-pdf', {
        params: { year: reportYear, month: reportMonth },
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' }));
      setPdfUrl(url);
    } catch (e) {
      alert('Error al generar el PDF');
    }
    setPdfLoading(false);
  };

  const handleExportarExcel = async () => {
    try {
      const params = {};
      if (filtros.fecha_desde) params.fecha_desde = filtros.fecha_desde;
      if (filtros.fecha_hasta) params.fecha_hasta = filtros.fecha_hasta;
      const r = await API.get('/asistencia/exportar', { params, responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([r.data]));
      const a = document.createElement('a');
      a.href = url;
      a.download = 'asistencia_' + new Date().toISOString().slice(0, 10) + '.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (e) {}
  };

  useEffect(() => {
    const handleActualizada = () => {
      loadMiEstado();
      loadMisRegistros();
      if (permVer) {
        loadUsuariosEstado();
        loadRegistros(true);
        if (resumenMensual) loadResumenMensual(reportYear, reportMonth);
      }
    };
    const handleAvisoActualizado = () => {
      loadMiEstado();
      loadMisRegistros();
      loadMisHorasMes();
      loadMisAvisos();
      if (permVer) {
        loadUsuariosEstado();
        if (resumenMensual) loadResumenMensual(reportYear, reportMonth);
      }
    };
    socket.on('asistencia_actualizada', handleActualizada);
    socket.on('aviso_actualizado', handleAvisoActualizado);
    return () => {
      socket.off('asistencia_actualizada', handleActualizada);
      socket.off('aviso_actualizado', handleAvisoActualizado);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    permVer,
    loadMiEstado,
    loadMisRegistros,
    loadMisHorasMes,
    loadMisAvisos,
    loadUsuariosEstado,
    loadRegistros,
  ]);

  const handleMiAsistenciaSuccess = () => {
    loadMiEstado();
    loadMisRegistros();
    loadMisHorasMes();
    loadMisAvisos();
  };

  const handleCrearAviso = async () => {
    setAvisoGuardando(true);
    setAvisoError(null);
    try {
      await API.post('/asistencia/avisos', {
        fecha: avisoFecha,
        tipo: avisoTipo,
        motivo: avisoMotivo.trim() || null,
      });
      setAvisoOpen(false);
      setAvisoFecha(new Date().toISOString().slice(0, 10));
      setAvisoTipo('ausencia');
      setAvisoMotivo('');
      loadMisAvisos();
      if (permVer) loadUsuariosEstado();
    } catch (e) {
      setAvisoError(e.response?.data?.detail || 'Error al crear aviso');
    }
    setAvisoGuardando(false);
  };

  const handleCancelarAviso = async (id) => {
    try {
      await API.delete('/asistencia/avisos/' + id);
      loadMisAvisos();
      if (permVer) loadUsuariosEstado();
    } catch (e) {}
  };

  const handleGenerarQR = async () => {
    setQrGenError(null);
    setQrGenLoading(true);
    try {
      const r = await API.post('/asistencia/qr-sede', null, { params: { sede_codigo: qrGenSede } });
      if (r.data?.status === 'success') setQrGenResult(r.data.data);
      else setQrGenError(r.data?.detail || 'Error al generar QR');
    } catch (e) {
      console.error('[handleGenerarQR] Error:', e);
      setQrGenError(e.response?.data?.detail || 'Error al generar QR');
    } finally {
      setQrGenLoading(false);
    }
  };

  const loadQrsPorSede = async () => {
    setQrLoading(true);
    try {
      const r = await API.get('/asistencia/qr-por-sede');
      if (r.data.status === 'success') {
        setQrAll(r.data.data);
        const slug = localStorage.getItem('agorax_empresa_slug') || '';
        const map = {};
        for (const q of r.data.data) {
          const data = empresaUrl(slug) + '/asistencia?token=' + q.token;
          try {
            const url = await toDataURL(data, {
              width: 220,
              margin: 2,
              color: { dark: BRAND_BLUE, light: '#FFFFFF' },
            });
            map[q.sede_codigo] = url;
          } catch (e2) {}
        }
        setQrImageMap(map);
      }
    } catch (e) {}
    setQrLoading(false);
  };

  const handleRegenerarQr = async (sedeCodigo) => {
    try {
      await API.post('/asistencia/qr-sede', null, { params: { sede_codigo: sedeCodigo } });
      loadQrsPorSede();
      setQrRegenConfirm(null);
    } catch (e) {
      alert(e.response?.data?.detail || 'Error al regenerar QR');
    }
  };

  const handleOpenQRGen = async () => {
    setQrGenOpen(true);
    setQrGenResult(null);
    setQrGenError(null);
    setQrGenSede('');
    setQrImageUrl(null);
    setQrGenLoading(false);
    try {
      await loadSedes();
    } catch (e) {
      console.error('[handleOpenQRGen] Error cargando sedes:', e);
    }
  };

  const loadUsuarioResumen = async (cedula, year, month) => {
    try {
      const r = await API.get('/asistencia/usuario-resumen/' + cedula, { params: { year, month } });
      if (r.data.status === 'success') setUsuarioResumen(r.data.data);
    } catch (e) {}
  };

  const handleUserDetail = async (u) => {
    setUserDetail(u);
    setUserStats(null);
    setUsuarioResumen(null);
    const now = new Date();
    setUserDetailMonth(now.getMonth() + 1);
    setUserDetailYear(now.getFullYear());
    try {
      const [r1, r2, r3] = await Promise.all([
        API.get('/asistencia/registros', { params: { usuario_cedula: u.cedula, limite: 50 } }),
        API.get('/asistencia/usuario-stats/' + u.cedula),
        API.get('/asistencia/usuario-resumen/' + u.cedula, {
          params: { year: now.getFullYear(), month: now.getMonth() + 1 },
        }),
      ]);
      if (r1.data.status === 'success') setUserDetailRegs(r1.data.data);
      else setUserDetailRegs([]);
      if (r2.data.status === 'success') setUserStats(r2.data.data);
      if (r3.data.status === 'success') setUsuarioResumen(r3.data.data);
    } catch (e) {
      setUserDetailRegs([]);
    }
  };

  const navigateUserMonth = (dir) => {
    let m = userDetailMonth + dir;
    let y = userDetailYear;
    if (m < 1) {
      m = 12;
      y--;
    }
    if (m > 12) {
      m = 1;
      y++;
    }
    setUserDetailMonth(m);
    setUserDetailYear(y);
    if (userDetail) loadUsuarioResumen(userDetail.cedula, y, m);
  };

  const handleRegistrarManual = async () => {
    if (!manualTipo) return;
    try {
      const params = { tipo: manualTipo, usuario_cedula: userDetail.cedula };
      if (manualSede) params.sede_codigo = manualSede;
      if (manualNotas) params.notas = manualNotas;
      if (manualHora) params.hora_manual = manualHora;
      await API.post('/asistencia/registrar-manual', null, { params });
      setManualOpen(false);
      setManualTipo('entrada');
      setManualSede('');
      setManualNotas('');
      setManualHora('');
      handleUserDetail(userDetail);
      loadUsuariosEstado();
    } catch (e) {
      alert(e.response?.data?.detail || 'Error al registrar');
    }
  };

  const openEditRegistro = (r) => {
    setEditRegistro(r);
    setEditTipo(r.tipo || 'entrada');
    setEditSede(r.sede_codigo || '');
    setEditNotas(r.notas || '');
    const d = r.hora_registro ? new Date(r.hora_registro) : new Date();
    const pad = (v) => String(v).padStart(2, '0');
    setEditHora(
      `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(
        d.getMinutes()
      )}`
    );
  };

  const handleCorregirRegistro = async () => {
    if (!editRegistro) return;
    setEditSaving(true);
    try {
      const params = { tipo: editTipo, hora: editHora };
      if (editSede) params.sede_codigo = editSede;
      if (editNotas) params.notas = editNotas;
      await API.patch('/asistencia/registros/' + editRegistro.id, null, { params });
      setEditRegistro(null);
      loadRegistros(true);
      loadUsuariosEstado();
      if (userDetail) handleUserDetail(userDetail);
    } catch (e) {
      alert(e.response?.data?.detail || 'Error al corregir el registro');
    }
    setEditSaving(false);
  };

  const openNuevoRegistro = () => {
    const n = new Date();
    const pad = (v) => String(v).padStart(2, '0');
    setNuevoUsuario('');
    setNuevoTipo('entrada');
    setNuevoHora(
      `${n.getFullYear()}-${pad(n.getMonth() + 1)}-${pad(n.getDate())}T${pad(n.getHours())}:${pad(
        n.getMinutes()
      )}`
    );
    setNuevoSede('');
    setNuevoNotas('');
    setNuevoOpen(true);
  };

  const handleCrearRegistro = async () => {
    if (!nuevoUsuario) {
      alert('Selecciona un usuario');
      return;
    }
    setNuevoSaving(true);
    try {
      const params = { tipo: nuevoTipo, usuario_cedula: nuevoUsuario };
      if (nuevoSede) params.sede_codigo = nuevoSede;
      if (nuevoNotas) params.notas = nuevoNotas;
      if (nuevoHora) params.hora_manual = nuevoHora;
      await API.post('/asistencia/registrar-manual', null, { params });
      setNuevoOpen(false);
      loadRegistros(true);
      loadUsuariosEstado();
    } catch (e) {
      alert(e.response?.data?.detail || 'Error al registrar');
    }
    setNuevoSaving(false);
  };

  const handleExportarPDFUsuario = async () => {
    setPdfLoadingUsuario(true);
    try {
      const r = await API.get('/asistencia/exportar-pdf-usuario/' + userDetail.cedula, {
        params: { year: userDetailYear, month: userDetailMonth },
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' }));
      setPdfUrlUsuario(url);
    } catch (e) {
      alert('Error al generar el PDF');
    }
    setPdfLoadingUsuario(false);
  };

  const formatTime = (iso) =>
    iso
      ? new Date(iso).toLocaleTimeString('es-VE', { hour: '2-digit', minute: '2-digit' })
      : '--:--';
  const formatFecha = (iso) =>
    iso
      ? new Date(iso).toLocaleDateString('es-VE', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        }) +
        ' ' +
        formatTime(iso)
      : '';
  const timeSince = (iso) => {
    if (!iso) return '';
    const mins = Math.floor((Date.now() - new Date(iso).getTime()) / 60000);
    if (mins < 60) return mins + 'm';
    const hrs = Math.floor(mins / 60);
    return hrs + 'h ' + (mins % 60) + 'm';
  };

  const paresPorDia = (regs) => {
    const sorted = [...regs].sort(
      (a, b) => new Date(a.hora_registro) - new Date(b.hora_registro)
    );
    // Agrupar por jornada: la jornada se atribuye a la fecha de la ENTRADA
    // (soporta turnos nocturnos que cruzan medianoche).
    const jornadas = [];
    for (const r of sorted) {
      if (r.tipo === 'entrada') {
        jornadas.push({ entrada: r, salida: null });
      } else {
        let asignada = false;
        for (let i = jornadas.length - 1; i >= 0; i--) {
          if (jornadas[i].salida === null) {
            jornadas[i].salida = r;
            asignada = true;
            break;
          }
        }
        if (!asignada) jornadas.push({ entrada: null, salida: r });
      }
    }
    const dias = [];
    for (const j of jornadas) {
      const ref = j.entrada || j.salida;
      if (!ref) continue;
      const d = new Date(ref.hora_registro);
      const key = d.toLocaleDateString('es-VE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      });
      let cur = dias[dias.length - 1];
      if (!cur || cur.fecha !== key) {
        cur = { fecha: key, ts: d.getTime(), pares: [] };
        dias.push(cur);
      }
      cur.pares.push(j);
    }
    return dias;
  };

  const soloAvisos = userSearch === '__avisos__';
  const searchTerm = soloAvisos ? '' : userSearch;
  const filteredUsuarios = usuariosEstado.filter((u) => {
    if (soloAvisos && !u.aviso_tipo) return false;
    if (
      searchTerm &&
      !u.nombre.toLowerCase().includes(searchTerm.toLowerCase()) &&
      !u.cedula.toLowerCase().includes(searchTerm.toLowerCase())
    )
      return false;
    return true;
  });

  const activos = usuariosEstado.filter((u) => u.activo).length;
  const sinRegistrar = usuariosEstado.filter((u) => !u.activo && u.tarde).length;
  const inactivos = usuariosEstado.filter((u) => !u.activo && !u.tarde).length;

  return (
    <div style={ST.page}>
      <div style={{ marginBottom: '20px' }}>
        <h1 style={ST.h1}>Asistencia</h1>
        <div style={ST.sub}>
          {usuario?.nombre} - {miEstado?.activo ? 'Activo' : 'Inactivo'}
        </div>
      </div>

      <div style={ST.tabsContainer}>
        <button style={ST.tab(tab === 'mi-asistencia')} onClick={() => setTab('mi-asistencia')}>
          Mi Asistencia
        </button>
        {permVer && (
          <button style={ST.tab(tab === 'usuarios')} onClick={() => setTab('usuarios')}>
            Panel Usuarios
          </button>
        )}
        {permVer && (
          <button style={ST.tab(tab === 'registros')} onClick={() => setTab('registros')}>
            Registros
          </button>
        )}
        {permVer && (
          <button style={ST.tab(tab === 'reportes')} onClick={() => setTab('reportes')}>
            Reportes
          </button>
        )}
        {permGest && (
          <button style={ST.tab(tab === 'horarios')} onClick={() => setTab('horarios')}>
            Horarios
          </button>
        )}
        {permGest && (
          <button style={ST.tab(tab === 'qrs')} onClick={() => setTab('qrs')}>
            QRs
          </button>
        )}
      </div>

      <AsistenciaModal
        open={showAsistenciaModal}
        onClose={() => setShowAsistenciaModal(false)}
        onSuccess={handleMiAsistenciaSuccess}
        miEstado={miEstado}
      />

      {/* ── MI ASISTENCIA ── */}
      {tab === 'mi-asistencia' && (
        <>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {/* Status hero card */}
            <div
              style={{
                ...ST.card,
                background: miEstado?.activo
                  ? `linear-gradient(135deg, ${isDark() ? '#064e3b' : '#f0fdf4'} 0%, ${isDark() ? '#064e3b' : '#dcfce7'} 100%)`
                  : `linear-gradient(135deg, var(--agx-bg2) 0%, ${isDark() ? '#1e293b' : '#f1f5f9'} 100%)`,
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  flexWrap: 'wrap',
                  gap: '16px',
                }}
              >
                <div>
                  <div
                    style={{
                      fontSize: '13px',
                      color: 'var(--agx-muted)',
                      marginBottom: '6px',
                      fontWeight: 500,
                    }}
                  >
                    Estado actual
                  </div>
                  <div
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '10px',
                      fontSize: '28px',
                      fontWeight: 700,
                      color: miEstado?.activo ? '#16a34a' : 'var(--agx-muted)',
                    }}
                  >
                    <span
                      style={{
                        width: '16px',
                        height: '16px',
                        borderRadius: '50%',
                        background: miEstado?.activo ? '#16a34a' : '#94a3b8',
                        display: 'inline-block',
                        boxShadow: miEstado?.activo ? '0 0 0 4px rgba(22,163,74,0.12)' : 'none',
                      }}
                    />
                    {miEstado?.activo ? 'Activo' : 'Inactivo'}
                  </div>
                  {miEstado?.ultimo_registro && (
                    <div
                      style={{
                        fontSize: '13px',
                        color: 'var(--agx-muted)',
                        marginTop: '6px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                      }}
                    >
                      <span style={ST.badge(S_COLORS[miEstado.ultimo_registro.tipo])}>
                        {miEstado.ultimo_registro.tipo === 'entrada' ? 'Entrada' : 'Salida'}
                      </span>
                      {formatTime(miEstado.ultimo_registro.hora_registro)}
                    </div>
                  )}
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button
                    onClick={() => setShowAsistenciaModal(true)}
                    style={{ ...ST.btn(BRAND_BLUE), padding: '12px 24px', fontSize: '15px' }}
                  >
                    <FiClock size={16} /> Reportar asistencia
                  </button>
                </div>
              </div>
            </div>

            {misHorasMes && (
              <>
                <div style={ST.card}>
                  <div
                    style={{
                      fontSize: '14px',
                      fontWeight: 700,
                      color: 'var(--agx-text)',
                      marginBottom: '12px',
                    }}
                  >
                    Este mes
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: isMobile ? '12px' : '20px',
                      flexWrap: 'wrap',
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <div
                        style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '12px',
                          background: isDark() ? '#064e3b' : '#f0fdf4',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <FiClock size={18} color="#16a34a" />
                      </div>
                      <div>
                        <div style={{ fontSize: '11px', color: 'var(--agx-muted)' }}>
                          Trabajadas
                        </div>
                        <div style={{ fontSize: '18px', fontWeight: 700, color: '#16a34a' }}>
                          {misHorasMes.horas_mes}h
                        </div>
                      </div>
                    </div>
                    {misHorasMes.horas_esperadas > 0 && (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <div
                          style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '12px',
                            background: 'var(--agx-bg2)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <FiClock size={18} color="#6b7280" />
                        </div>
                        <div>
                          <div style={{ fontSize: '11px', color: 'var(--agx-muted)' }}>
                            Meta del mes
                          </div>
                          <div
                            style={{ fontSize: '18px', fontWeight: 700, color: 'var(--agx-muted)' }}
                          >
                            {misHorasMes.horas_esperadas}h
                          </div>
                        </div>
                      </div>
                    )}
                    {misHorasMes.minutos_extra != null && (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <div
                          style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '12px',
                            background:
                              misHorasMes.minutos_extra > 0
                                ? isDark()
                                  ? '#064e3b'
                                  : '#f0fdf4'
                                : 'var(--agx-bg2)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <span
                            style={{
                              fontSize: '14px',
                              fontWeight: 700,
                              color: misHorasMes.minutos_extra > 0 ? '#16a34a' : 'var(--agx-muted)',
                            }}
                          >
                            +
                          </span>
                        </div>
                        <div>
                          <div style={{ fontSize: '11px', color: 'var(--agx-muted)' }}>Extra</div>
                          <div
                            style={{
                              fontSize: '18px',
                              fontWeight: 700,
                              color: misHorasMes.minutos_extra > 0 ? '#16a34a' : 'var(--agx-muted)',
                            }}
                          >
                            {misHorasMes.minutos_extra}m
                          </div>
                        </div>
                      </div>
                    )}
                    {misHorasMes.minutos_atraso != null && (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <div
                          style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '12px',
                            background:
                              misHorasMes.minutos_atraso > 0
                                ? isDark()
                                  ? '#7f1d1d'
                                  : '#fef2f2'
                                : 'var(--agx-bg2)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <FiClock
                            size={18}
                            color={misHorasMes.minutos_atraso > 0 ? '#dc2626' : '#94a3b8'}
                          />
                        </div>
                        <div>
                          <div style={{ fontSize: '11px', color: 'var(--agx-muted)' }}>Atraso</div>
                          <div
                            style={{
                              fontSize: '18px',
                              fontWeight: 700,
                              color:
                                misHorasMes.minutos_atraso > 0 ? '#dc2626' : 'var(--agx-muted)',
                            }}
                          >
                            {misHorasMes.minutos_atraso}m
                          </div>
                        </div>
                      </div>
                    )}
                    {misHorasMes.horas_esperadas > 0 && (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <div
                          style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '12px',
                            background:
                              misHorasMes.balance >= 0
                                ? isDark()
                                  ? '#064e3b'
                                  : '#f0fdf4'
                                : isDark()
                                  ? '#7f1d1d'
                                  : '#fef2f2',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <span
                            style={{
                              fontSize: '14px',
                              fontWeight: 700,
                              color: misHorasMes.balance >= 0 ? '#16a34a' : '#dc2626',
                            }}
                          >
                            {misHorasMes.balance >= 0 ? '+' : '-'}
                          </span>
                        </div>
                        <div>
                          <div style={{ fontSize: '11px', color: 'var(--agx-muted)' }}>
                            Faltante
                          </div>
                          <div
                            style={{
                              fontSize: '18px',
                              fontWeight: 700,
                              color: misHorasMes.balance >= 0 ? '#16a34a' : '#dc2626',
                            }}
                          >
                            {Math.abs(misHorasMes.balance)}h
                          </div>
                        </div>
                      </div>
                    )}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <div
                        style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '12px',
                          background: isDark() ? '#1e3a5f' : '#eff6ff',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <FiCalendar size={18} color={ACCENT_BLUE} />
                      </div>
                      <div>
                        <div style={{ fontSize: '11px', color: 'var(--agx-muted)' }}>Dias</div>
                        <div style={{ fontSize: '18px', fontWeight: 700, color: ACCENT_BLUE }}>
                          {misHorasMes.dias_registrados}
                        </div>
                      </div>
                    </div>
                    {misHorasMes.alertas_mes > 0 && (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <div
                          style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '12px',
                            background: isDark() ? '#7f1d1d' : '#fef2f2',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <FiAlertTriangle size={18} color="#dc2626" />
                        </div>
                        <div>
                          <div style={{ fontSize: '11px', color: 'var(--agx-muted)' }}>
                            Retrasos
                          </div>
                          <div style={{ fontSize: '18px', fontWeight: 700, color: '#dc2626' }}>
                            {misHorasMes.alertas_mes}
                          </div>
                        </div>
                      </div>
                    )}
                    {misHorasMes.inasistencias_mes != null && (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <div
                          style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '12px',
                            background:
                              misHorasMes.inasistencias_mes > 0
                                ? isDark()
                                  ? '#7f1d1d'
                                  : '#fef2f2'
                                : 'var(--agx-bg2)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <FiX
                            size={18}
                            color={misHorasMes.inasistencias_mes > 0 ? '#dc2626' : '#94a3b8'}
                          />
                        </div>
                        <div>
                          <div style={{ fontSize: '11px', color: 'var(--agx-muted)' }}>Faltas</div>
                          <div
                            style={{
                              fontSize: '18px',
                              fontWeight: 700,
                              color:
                                misHorasMes.inasistencias_mes > 0 ? '#dc2626' : 'var(--agx-muted)',
                            }}
                          >
                            {misHorasMes.inasistencias_mes}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {misHorasMes.horario && (
                  <div style={{ ...ST.card, padding: '14px 20px' }}>
                    <div
                      style={{
                        fontSize: '13px',
                        fontWeight: 600,
                        color: 'var(--agx-text)',
                        marginBottom: '6px',
                      }}
                    >
                      Tu horario
                    </div>
                    {misHorasMes.horario.horarios_json ? (
                      <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                        {Object.entries(misHorasMes.horario.horarios_json)
                          .sort(([a], [b]) => parseInt(a) - parseInt(b))
                          .map(([d, val]) => (
                            <span
                              key={d}
                              style={{
                                fontSize: '12px',
                                fontWeight: 500,
                                color: '#16a34a',
                                background: isDark() ? '#064e3b' : '#f0fdf4',
                                padding: '3px 8px',
                                borderRadius: '6px',
                                border: '1px solid #bbf7d0',
                              }}
                            >
                              {
                                {
                                  1: 'Lun',
                                  2: 'Mar',
                                  3: 'Mie',
                                  4: 'Jue',
                                  5: 'Vie',
                                  6: 'Sab',
                                  7: 'Dom',
                                }[d]
                              }{' '}
                              {val.entrada}-{val.salida}
                            </span>
                          ))}
                      </div>
                    ) : (
                      <span
                        style={{ fontSize: '13px', color: 'var(--agx-muted)', fontWeight: 500 }}
                      >
                        {misHorasMes.horario.entrada || '--:--'} -{' '}
                        {misHorasMes.horario.salida || '--:--'}
                        {misHorasMes.horario.tolerancia != null && (
                          <span
                            style={{
                              fontSize: '11px',
                              color: 'var(--agx-faint)',
                              marginLeft: '8px',
                            }}
                          >
                            ±{misHorasMes.horario.tolerancia}min
                          </span>
                        )}
                      </span>
                    )}
                  </div>
                )}

                {misHorasMes.resumen_semana && (
                  <div style={ST.card}>
                    <div
                      style={{
                        fontSize: '14px',
                        fontWeight: 700,
                        color: 'var(--agx-text)',
                        marginBottom: '8px',
                      }}
                    >
                      Esta semana
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: isMobile ? '10px' : '16px',
                        flexWrap: 'wrap',
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <FiCalendar size={14} color={ACCENT_BLUE} />
                        <span
                          style={{ fontSize: '13px', fontWeight: 600, color: 'var(--agx-text)' }}
                        >
                          {misHorasMes.resumen_semana.dias_trabajados}/
                          {misHorasMes.resumen_semana.dias_esperados} dias
                        </span>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <FiClock size={14} color="#16a34a" />
                        <span style={{ fontSize: '13px', fontWeight: 600, color: '#16a34a' }}>
                          {misHorasMes.resumen_semana.horas_semana}h
                          {misHorasMes.resumen_semana.horas_semana_esperadas > 0 && (
                            <span
                              style={{
                                fontSize: '11px',
                                fontWeight: 400,
                                color: 'var(--agx-faint)',
                              }}
                            >
                              {' '}
                              de {misHorasMes.resumen_semana.horas_semana_esperadas}h
                            </span>
                          )}
                        </span>
                      </div>
                      {misHorasMes.resumen_semana.horas_semana_esperadas > 0 && (
                        <div
                          style={{
                            flex: 1,
                            height: '6px',
                            borderRadius: '3px',
                            background: 'var(--agx-border)',
                            minWidth: '80px',
                            overflow: 'hidden',
                          }}
                        >
                          <div
                            style={{
                              height: '100%',
                              borderRadius: '3px',
                              background: '#16a34a',
                              width:
                                Math.min(
                                  100,
                                  (misHorasMes.resumen_semana.horas_semana /
                                    misHorasMes.resumen_semana.horas_semana_esperadas) *
                                    100
                                ) + '%',
                              transition: 'width 0.3s',
                            }}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {misHorasMes.calendario && (
                  <div style={ST.card}>
                    <div
                      style={{
                        fontSize: '14px',
                        fontWeight: 700,
                        color: 'var(--agx-text)',
                        marginBottom: '10px',
                      }}
                    >
                      {
                        [
                          'Ene',
                          'Feb',
                          'Mar',
                          'Abr',
                          'May',
                          'Jun',
                          'Jul',
                          'Ago',
                          'Sep',
                          'Oct',
                          'Nov',
                          'Dic',
                        ][misHorasMes.month - 1]
                      }{' '}
                      {misHorasMes.year}
                    </div>
                    <div
                      style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '3px' }}
                    >
                      {['L', 'M', 'X', 'J', 'V', 'S', 'D'].map((l) => (
                        <div
                          key={l}
                          style={{
                            textAlign: 'center',
                            fontSize: '10px',
                            fontWeight: 600,
                            color: 'var(--agx-faint)',
                            padding: '2px',
                          }}
                        >
                          {l}
                        </div>
                      ))}
                      {(() => {
                        const firstDay = new Date(
                          misHorasMes.year,
                          misHorasMes.month - 1,
                          1
                        ).getDay();
                        const offset = firstDay === 0 ? 6 : firstDay - 1;
                        const cells = [];
                        for (let i = 0; i < offset; i++) cells.push(<div key={'e' + i} />);
                        misHorasMes.calendario.forEach((c) => {
                          const colors = {
                            asistio: '#16a34a',
                            retraso: '#f59e0b',
                            aviso: '#7c3aed',
                            falta: '#dc2626',
                            futuro: 'var(--agx-border)',
                          };
                          const bg =
                            c.status === 'asistio'
                              ? isDark()
                                ? '#064e3b'
                                : '#f0fdf4'
                              : c.status === 'retraso'
                                ? isDark()
                                  ? '#78350f'
                                  : '#fffbeb'
                                : c.status === 'aviso'
                                  ? isDark()
                                    ? '#2d1f6b'
                                    : '#f3e8ff'
                                  : c.status === 'falta'
                                    ? isDark()
                                      ? '#7f1d1d'
                                      : '#fef2f2'
                                    : 'var(--agx-bg2)';
                          cells.push(
                            <div
                              key={c.dia}
                              style={{
                                textAlign: 'center',
                                padding: '4px 0',
                                borderRadius: '6px',
                                background: bg,
                                border: c.es_hoy
                                  ? '1.5px solid ' + ACCENT_BLUE
                                  : '1px solid transparent',
                              }}
                            >
                              <div
                                style={{
                                  fontSize: '10px',
                                  fontWeight: c.es_hoy ? 700 : 400,
                                  color: c.es_hoy ? ACCENT_BLUE : 'var(--agx-muted)',
                                }}
                              >
                                {c.dia}
                              </div>
                              {c.status && c.status !== 'futuro' && (
                                <div
                                  style={{
                                    width: '5px',
                                    height: '5px',
                                    borderRadius: '50%',
                                    background: colors[c.status] || 'var(--agx-muted)',
                                    margin: '2px auto 0',
                                  }}
                                />
                              )}
                            </div>
                          );
                        });
                        return cells;
                      })()}
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        gap: '12px',
                        marginTop: '8px',
                        fontSize: '10px',
                        color: 'var(--agx-muted)',
                        flexWrap: 'wrap',
                        justifyContent: 'center',
                      }}
                    >
                      <span>
                        <span
                          style={{
                            display: 'inline-block',
                            width: '6px',
                            height: '6px',
                            borderRadius: '50%',
                            background: '#16a34a',
                            marginRight: '3px',
                            verticalAlign: 'middle',
                          }}
                        />
                        Asistio
                      </span>
                      <span>
                        <span
                          style={{
                            display: 'inline-block',
                            width: '6px',
                            height: '6px',
                            borderRadius: '50%',
                            background: '#f59e0b',
                            marginRight: '3px',
                            verticalAlign: 'middle',
                          }}
                        />
                        Retraso
                      </span>
                      <span>
                        <span
                          style={{
                            display: 'inline-block',
                            width: '6px',
                            height: '6px',
                            borderRadius: '50%',
                            background: '#7c3aed',
                            marginRight: '3px',
                            verticalAlign: 'middle',
                          }}
                        />
                        Aviso
                      </span>
                      <span>
                        <span
                          style={{
                            display: 'inline-block',
                            width: '6px',
                            height: '6px',
                            borderRadius: '50%',
                            background: '#dc2626',
                            marginRight: '3px',
                            verticalAlign: 'middle',
                          }}
                        />
                        Falta
                      </span>
                    </div>
                  </div>
                )}
              </>
            )}

            <div
              style={{
                ...ST.card,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: '10px',
              }}
            >
              <div style={{ fontSize: '14px', fontWeight: 600, color: 'var(--agx-text)' }}>
                Avisos
              </div>
              <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                <button
                  onClick={() => {
                    setAvisoTipo('ausencia');
                    setAvisoFecha(new Date().toISOString().slice(0, 10));
                    setAvisoOpen(true);
                  }}
                  style={ST.btnOutline}
                >
                  <FiAlertTriangle size={14} /> Avisar ausencia
                </button>
                <button
                  onClick={() => {
                    setAvisoTipo('llegada_tarde');
                    setAvisoFecha(new Date().toISOString().slice(0, 10));
                    setAvisoOpen(true);
                  }}
                  style={{ ...ST.btnOutline, color: '#f59e0b', borderColor: '#f59e0b' }}
                >
                  <FiClock size={14} /> Avisar llegada tarde
                </button>
              </div>
            </div>
            {misAvisos.length > 0 && (
              <div style={ST.card}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  {misAvisos.map((a) => (
                    <div
                      key={a.id}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: '10px',
                        padding: '8px 12px',
                        borderRadius: '10px',
                        background:
                          a.tipo === 'ausencia'
                            ? isDark()
                              ? '#7f1d1d'
                              : '#fef2f2'
                            : isDark()
                              ? '#78350f'
                              : '#fffbeb',
                        border: a.tipo === 'ausencia' ? '1px solid #fecaca' : '1px solid #fde68a',
                        fontSize: '13px',
                        flexWrap: 'wrap',
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          flexWrap: 'wrap',
                        }}
                      >
                        <span style={{ fontWeight: 600, color: 'var(--agx-text)' }}>
                          {new Date(a.fecha + 'T12:00:00').toLocaleDateString('es-VE', {
                            weekday: 'short',
                            day: 'numeric',
                            month: 'short',
                          })}
                        </span>
                        <span
                          style={{ ...ST.badge(a.tipo === 'ausencia' ? '#dc2626' : '#f59e0b') }}
                        >
                          {a.tipo === 'ausencia' ? 'Ausencia' : 'Llegada tarde'}
                        </span>
                        {a.motivo && (
                          <span style={{ color: 'var(--agx-muted)', fontSize: '12px' }}>
                            {a.motivo}
                          </span>
                        )}
                      </div>
                      <button
                        onClick={() => handleCancelarAviso(a.id)}
                        style={{
                          padding: '4px 10px',
                          borderRadius: '8px',
                          border: 'none',
                          background: 'rgba(0,0,0,0.05)',
                          color: 'var(--agx-muted)',
                          fontSize: '12px',
                          fontWeight: 600,
                          cursor: 'pointer',
                          fontFamily: 'inherit',
                        }}
                      >
                        Cancelar
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div style={ST.card}>
              <div style={ST.sectionTitle}>
                <FiClock size={14} /> Historial reciente
              </div>
              {misRegistros.length === 0 && <div style={ST.emptyState}>Sin registros aun</div>}
              {misRegistros.map((r, i) => (
                <div
                  key={r.id}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    padding: '10px 0',
                    borderBottom:
                      i < misRegistros.length - 1 ? '1px solid var(--agx-skeleton)' : 'none',
                    fontSize: '13px',
                  }}
                >
                  <span style={{ fontWeight: 600, minWidth: '48px', color: 'var(--agx-text)' }}>
                    {formatTime(r.hora_registro)}
                  </span>
                  <span style={ST.badge(S_COLORS[r.tipo])}>
                    {r.tipo === 'entrada' ? 'Entrada' : 'Salida'}
                  </span>
                  <span style={{ color: 'var(--agx-faint)', fontSize: '12px' }}>
                    {new Date(r.hora_registro).toLocaleDateString('es-VE', {
                      day: '2-digit',
                      month: '2-digit',
                    })}
                  </span>
                  {r.alerta_tipo && (
                    <span style={ST.alertaBadge(r.alerta_tipo)}>
                      <FiAlertTriangle size={11} />
                      {RETRASO_LABELS[r.alerta_tipo] || r.alerta_tipo}
                    </span>
                  )}
                  {r.notas && (
                    <span
                      style={{
                        color: 'var(--agx-faint)',
                        flex: 1,
                        textAlign: 'right',
                        fontSize: '12px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {r.notas}
                    </span>
                  )}
                </div>
              ))}
            </div>
          </div>

          {avisoOpen && (
            <div
              style={ST.modal}
              onClick={(e) => {
                if (e.target === e.currentTarget) {
                  setAvisoOpen(false);
                  setAvisoError(null);
                }
              }}
            >
              <div style={ST.modalContent()}>
                <button
                  onClick={() => {
                    setAvisoOpen(false);
                    setAvisoError(null);
                  }}
                  style={{
                    position: 'absolute',
                    top: '16px',
                    right: '16px',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    color: '#94a3b8',
                    padding: '6px',
                    borderRadius: '8px',
                  }}
                >
                  <FiX size={20} />
                </button>
                <div
                  style={{
                    fontSize: '18px',
                    fontWeight: 700,
                    color: 'var(--agx-text)',
                    marginBottom: '16px',
                  }}
                >
                  {avisoTipo === 'ausencia' ? 'Avisar ausencia' : 'Avisar llegada tarde'}
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
                  <div>
                    <label
                      style={{
                        display: 'block',
                        fontSize: '13px',
                        fontWeight: 600,
                        color: 'var(--agx-muted)',
                        marginBottom: '4px',
                      }}
                    >
                      Fecha
                    </label>
                    <input
                      type="date"
                      value={avisoFecha}
                      min={new Date().toISOString().slice(0, 10)}
                      onChange={(e) => setAvisoFecha(e.target.value)}
                      style={{ ...ST.input, maxWidth: '100%', width: '100%' }}
                    />
                  </div>
                  <div>
                    <label
                      style={{
                        display: 'block',
                        fontSize: '13px',
                        fontWeight: 600,
                        color: 'var(--agx-muted)',
                        marginBottom: '4px',
                      }}
                    >
                      Motivo (opcional)
                    </label>
                    <textarea
                      value={avisoMotivo}
                      onChange={(e) => setAvisoMotivo(e.target.value)}
                      placeholder="Ej: cita medica, problema personal..."
                      rows={3}
                      style={{
                        width: '100%',
                        padding: '10px 12px',
                        borderRadius: '10px',
                        border: '1.5px solid var(--agx-skeleton)',
                        fontSize: '13px',
                        fontFamily: 'inherit',
                        resize: 'vertical',
                        minHeight: '60px',
                        boxSizing: 'border-box',
                      }}
                    />
                  </div>
                  {avisoError && (
                    <div
                      style={{
                        background: isDark() ? '#7f1d1d' : '#fef2f2',
                        color: '#dc2626',
                        borderRadius: '10px',
                        padding: '12px',
                        fontSize: '13px',
                      }}
                    >
                      {avisoError}
                    </div>
                  )}
                  <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                    <button
                      onClick={() => {
                        setAvisoOpen(false);
                        setAvisoError(null);
                      }}
                      style={ST.btnOutline}
                    >
                      Cancelar
                    </button>
                    <button
                      onClick={handleCrearAviso}
                      disabled={avisoGuardando || !avisoFecha}
                      style={{
                        ...ST.btn(avisoTipo === 'ausencia' ? '#dc2626' : '#f59e0b'),
                        opacity: avisoGuardando || !avisoFecha ? 0.5 : 1,
                      }}
                    >
                      {avisoGuardando ? 'Guardando...' : 'Guardar aviso'}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}

      {/* ── PANEL DE USUARIOS ── */}
      {tab === 'usuarios' && (
        <div>
          <div style={{ display: 'flex', gap: '12px', marginBottom: '16px', flexWrap: 'wrap' }}>
            <div style={ST.statCard('#16a34a')}>
              <FiUserCheck size={20} color="#16a34a" />
              <div>
                <div style={{ fontSize: '20px', fontWeight: 700, color: 'var(--agx-text)' }}>
                  {activos}
                </div>
                <div style={{ fontSize: '11px', color: 'var(--agx-muted)' }}>Activos</div>
              </div>
            </div>
            <div style={ST.statCard('#f59e0b')}>
              <FiBell size={20} color="#f59e0b" />
              <div>
                <div style={{ fontSize: '20px', fontWeight: 700, color: 'var(--agx-text)' }}>
                  {sinRegistrar}
                </div>
                <div style={{ fontSize: '11px', color: 'var(--agx-muted)' }}>Sin registrar</div>
              </div>
            </div>
            <div style={ST.statCard('#94a3b8')}>
              <FiUserX size={20} color="#94a3b8" />
              <div>
                <div style={{ fontSize: '20px', fontWeight: 700, color: 'var(--agx-text)' }}>
                  {inactivos}
                </div>
                <div style={{ fontSize: '11px', color: 'var(--agx-muted)' }}>Inactivos</div>
              </div>
            </div>
            <div style={ST.statCard('#7c3aed')}>
              <FiAlertTriangle size={20} color="#7c3aed" />
              <div>
                <div style={{ fontSize: '20px', fontWeight: 700, color: 'var(--agx-text)' }}>
                  {usuariosEstado.filter((u) => u.aviso_tipo).length}
                </div>
                <div style={{ fontSize: '11px', color: 'var(--agx-muted)' }}>Avisos hoy</div>
              </div>
            </div>
          </div>

          {usuariosEstado.filter((u) => u.aviso_tipo).length > 0 && (
            <div
              style={{
                background: isDark() ? '#2d1f6b' : '#f3e8ff',
                borderRadius: '12px',
                padding: '12px 16px',
                marginBottom: '16px',
                border: '1px solid #d8b4fe',
                display: 'flex',
                flexDirection: 'column',
                gap: '6px',
              }}
            >
              <div
                style={{
                  fontSize: '12px',
                  fontWeight: 700,
                  color: '#7c3aed',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                }}
              >
                Avisos del dia
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
                {usuariosEstado
                  .filter((u) => u.aviso_tipo)
                  .map((u) => (
                    <div
                      key={u.cedula}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        fontSize: '13px',
                        cursor: 'pointer',
                      }}
                      onClick={() => handleUserDetail(u)}
                    >
                      <span style={{ fontWeight: 600, color: 'var(--agx-text)' }}>{u.nombre}</span>
                      <span
                        style={{
                          ...ST.badge(u.aviso_tipo === 'ausencia' ? '#7c3aed' : '#f59e0b'),
                          fontSize: '10px',
                        }}
                      >
                        {u.aviso_tipo === 'ausencia' ? 'Ausencia' : 'Llegada tarde'}
                      </span>
                      {u.aviso_motivo && (
                        <span
                          style={{
                            fontSize: '11px',
                            color: 'var(--agx-muted)',
                            fontStyle: 'italic',
                          }}
                        >
                          {u.aviso_motivo}
                        </span>
                      )}
                    </div>
                  ))}
              </div>
            </div>
          )}

          <div style={{ ...ST.flexRow, justifyContent: 'space-between', gap: '12px' }}>
            <div style={{ position: 'relative', flex: 1, maxWidth: isMobile ? '100%' : '360px' }}>
              <FiSearch
                size={14}
                color="#9ca3af"
                style={{
                  position: 'absolute',
                  left: '12px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                }}
              />
              <input
                placeholder="Buscar usuario..."
                value={searchTerm}
                onChange={(e) => setUserSearch(e.target.value)}
                style={ST.searchInput}
              />
            </div>
            <label
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                fontSize: '12px',
                fontWeight: 600,
                color: '#7c3aed',
                cursor: 'pointer',
                whiteSpace: 'nowrap',
              }}
            >
              <input
                type="checkbox"
                checked={userSearch === '__avisos__'}
                onChange={(e) => setUserSearch(e.target.checked ? '__avisos__' : '')}
                style={{ accentColor: '#7c3aed' }}
              />
              Solo con avisos
            </label>
          </div>

          <div style={ST.userGrid}>
            {filteredUsuarios.length === 0 && (
              <div style={{ ...ST.card, gridColumn: '1/-1' }}>
                <div style={ST.emptyState}>Cargando usuarios...</div>
              </div>
            )}
            {filteredUsuarios.map((u) => (
              <div
                key={u.cedula}
                style={ST.userCard(u.activo)}
                onClick={() => handleUserDetail(u)}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.06)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = '';
                  e.currentTarget.style.boxShadow = '0 1px 2px rgba(0,0,0,0.03)';
                }}
              >
                <div style={{ position: 'relative' }}>
                  <div style={ST.userDot(u.activo)} />
                  {u.tarde && (
                    <FiBell
                      size={12}
                      color="#f59e0b"
                      style={{ position: 'absolute', top: '-5px', left: '9px' }}
                    />
                  )}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div
                    style={{
                      fontSize: '14px',
                      fontWeight: 600,
                      color: 'var(--agx-text)',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px',
                      flexWrap: 'wrap',
                    }}
                  >
                    {u.nombre}
                    {u.aviso_tipo === 'ausencia' && (
                      <span
                        style={{
                          fontSize: '10px',
                          fontWeight: 600,
                          color: '#7c3aed',
                          background: isDark() ? '#2d1f6b' : '#f3e8ff',
                          padding: '1px 6px',
                          borderRadius: '6px',
                        }}
                      >
                        Aviso ausencia
                      </span>
                    )}
                    {u.aviso_tipo === 'llegada_tarde' && (
                      <span
                        style={{
                          fontSize: '10px',
                          fontWeight: 600,
                          color: '#f59e0b',
                          background: isDark() ? '#78350f' : '#fffbeb',
                          padding: '1px 6px',
                          borderRadius: '6px',
                        }}
                      >
                        Aviso retraso
                      </span>
                    )}
                    {!u.aviso_tipo && u.tarde && (
                      <span style={{ fontSize: '10px', color: '#f59e0b', fontWeight: 500 }}>
                        Sin registrar hoy
                      </span>
                    )}
                  </div>
                  <div style={{ fontSize: '12px', color: 'var(--agx-muted)' }}>
                    {u.rol}
                    {u.sede_asignada ? ' | ' + u.sede_asignada : ''}
                  </div>
                </div>
                <div style={{ textAlign: 'right', flexShrink: 0 }}>
                  <div
                    style={{
                      fontSize: '12px',
                      fontWeight: 600,
                      color:
                        u.aviso_tipo === 'ausencia'
                          ? '#7c3aed'
                          : u.activo
                            ? '#16a34a'
                            : u.tarde
                              ? '#f59e0b'
                              : 'var(--agx-muted)',
                    }}
                  >
                    {u.aviso_tipo === 'ausencia'
                      ? 'Ausencia'
                      : u.aviso_tipo === 'llegada_tarde'
                        ? 'Llegada tarde'
                        : u.activo
                          ? 'Activo'
                          : u.tarde
                            ? 'Tarde'
                            : 'Inactivo'}
                  </div>
                  {u.ultima_hora && (
                    <div style={{ fontSize: '11px', color: 'var(--agx-faint)' }}>
                      {u.ultimo_tipo === 'entrada' ? 'Entro ' : 'Salio '}
                      {timeSince(u.ultima_hora)}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>

          {/* QR Generation Modal */}
          {qrGenOpen && (
            <div
              style={ST.modal}
              onClick={(e) => {
                if (e.target === e.currentTarget) {
                  setQrGenOpen(false);
                  setQrGenResult(null);
                  setQrImageUrl(null);
                }
              }}
            >
              <div style={ST.modalContent(true)}>
                <button
                  onClick={() => {
                    setQrGenOpen(false);
                    setQrGenResult(null);
                    setQrImageUrl(null);
                  }}
                  style={{
                    position: 'absolute',
                    top: '16px',
                    right: '16px',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    color: '#94a3b8',
                    padding: '6px',
                    borderRadius: '8px',
                  }}
                >
                  <FiX size={20} />
                </button>
                <div
                  style={{
                    fontSize: '18px',
                    fontWeight: 700,
                    color: 'var(--agx-text)',
                    marginBottom: '16px',
                  }}
                >
                  Generar QR de Asistencia
                </div>

                {!qrGenResult && (
                  <>
                    <div style={{ marginBottom: '16px' }}>
                      <label
                        style={{
                          display: 'block',
                          fontSize: '14px',
                          fontWeight: 600,
                          color: 'var(--agx-muted)',
                          marginBottom: '8px',
                        }}
                      >
                        Selecciona una sede
                      </label>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        {sedes.length === 0 && (
                          <div style={{ color: 'var(--agx-faint)', fontSize: '13px' }}>
                            Cargando sedes...
                          </div>
                        )}
                        {sedes
                          .filter((s) => s.activa)
                          .map((s) => (
                            <label
                              key={s.codigo}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px',
                                padding: '12px 14px',
                                borderRadius: '12px',
                                border:
                                  qrGenSede === s.codigo
                                    ? '2px solid ' + ACCENT_BLUE
                                    : '1.5px solid var(--agx-border)',
                                background:
                                  qrGenSede === s.codigo
                                    ? isDark()
                                      ? '#1e3a5f'
                                      : '#eff6ff'
                                    : 'var(--agx-surface)',
                                cursor: 'pointer',
                                fontSize: '14px',
                                color: 'var(--agx-text)',
                                fontWeight: 500,
                                transition: 'all 0.15s',
                              }}
                            >
                              <input
                                type="radio"
                                name="sede"
                                value={s.codigo}
                                checked={qrGenSede === s.codigo}
                                onChange={(e) => setQrGenSede(e.target.value)}
                                style={{ accentColor: ACCENT_BLUE }}
                              />
                              <div>
                                <div style={{ fontWeight: 600 }}>{s.nombre}</div>
                                <div style={{ fontSize: '11px', color: 'var(--agx-faint)' }}>
                                  {s.codigo}
                                </div>
                              </div>
                            </label>
                          ))}
                      </div>
                    </div>
                    {qrGenError && (
                      <div
                        style={{
                          background: isDark() ? '#7f1d1d' : '#fef2f2',
                          color: '#dc2626',
                          borderRadius: '10px',
                          padding: '12px',
                          fontSize: '13px',
                          marginBottom: '12px',
                        }}
                      >
                        {qrGenError}
                      </div>
                    )}
                    <button
                      onClick={handleGenerarQR}
                      disabled={!qrGenSede || qrGenLoading}
                      style={{
                        ...ST.btn(BRAND_BLUE),
                        opacity: qrGenSede && !qrGenLoading ? 1 : 0.5,
                        width: '100%',
                        justifyContent: 'center',
                      }}
                    >
                      <FiMaximize size={14} /> {qrGenLoading ? 'Generando...' : 'Generar QR'}
                    </button>
                  </>
                )}

                {qrGenResult && (
                  <div style={{ textAlign: 'center' }}>
                    <div style={ST.confirmBox}>
                      <FiCheckCircle size={40} color="#16a34a" style={{ marginBottom: '8px' }} />
                      <div style={{ fontSize: '16px', fontWeight: 700, color: 'var(--agx-text)' }}>
                        QR Generado exitosamente
                      </div>
                      <div
                        style={{ fontSize: '14px', color: 'var(--agx-muted)', marginTop: '4px' }}
                      >
                        {qrGenResult.sede_nombre} ({qrGenResult.sede_codigo})
                      </div>
                      {qrImageUrl && (
                        <div
                          style={{
                            marginTop: '16px',
                            background: 'var(--agx-surface)',
                            padding: '16px',
                            borderRadius: '14px',
                            border: '1px solid var(--agx-border)',
                            display: 'inline-block',
                          }}
                        >
                          <img
                            src={qrImageUrl}
                            alt="QR"
                            style={{ width: '200px', height: '200px', borderRadius: '8px' }}
                          />
                        </div>
                      )}
                      <div
                        style={{
                          fontSize: '11px',
                          color: 'var(--agx-faint)',
                          marginTop: '8px',
                          fontWeight: 500,
                        }}
                      >
                        {qrGenResult.expira_en
                          ? 'Expira: ' + new Date(qrGenResult.expira_en).toLocaleDateString('es-VE')
                          : 'QR permanente - sin vencimiento'}
                      </div>
                    </div>
                    {qrImageUrl && (
                      <div
                        style={{
                          display: 'flex',
                          gap: '10px',
                          justifyContent: 'center',
                          flexWrap: 'wrap',
                        }}
                      >
                        <button
                          onClick={() => {
                            const a = document.createElement('a');
                            a.href = qrImageUrl;
                            a.download = 'QR_Asistencia_' + qrGenResult.sede_codigo + '.png';
                            a.click();
                          }}
                          style={ST.btn(ACCENT_BLUE)}
                        >
                          <FiDownload size={14} /> Descargar PNG
                        </button>
                        <button
                          onClick={() => {
                            const win = window.open('', '_blank');
                            win.document.write(
                              '<html><head><title>QR Asistencia - ' +
                                qrGenResult.sede_nombre +
                                '</title><style>body{display:flex;align-items:center;justify-content:center;height:100vh;margin:0;font-family:sans-serif}<div style="text-align:center;padding:32px"><h2 style="margin-bottom:8px">Asistencia - ' +
                                qrGenResult.sede_nombre +
                                '</h2><p style="color:#666;font-size:13px">Sede: ' +
                                qrGenResult.sede_codigo +
                                (qrGenResult.expira_en
                                  ? ' | Expira: ' +
                                    new Date(qrGenResult.expira_en).toLocaleDateString('es-VE')
                                  : ' | Permanente') +
                                '</p><img src="' +
                                qrImageUrl +
                                '" width="280" alt="QR" /><p style="margin-top:12px;font-size:11px;color:#999">Escanea para registrar entrada/salida</p></div></body></html>'
                            );
                            win.document.close();
                            setTimeout(function () {
                              win.print();
                            }, 500);
                          }}
                          style={ST.btnOutline}
                        >
                          Imprimir
                        </button>
                        <button
                          onClick={() => {
                            setQrGenOpen(false);
                            setQrGenResult(null);
                            setQrImageUrl(null);
                          }}
                          style={ST.btnOutline}
                        >
                          Cerrar
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}

          {/* User Detail Modal */}
          {userDetail && (
            <div
              style={ST.modal}
              onClick={(e) => {
                if (e.target === e.currentTarget) {
                  setUserDetail(null);
                  setUserDetailRegs([]);
                  setUserStats(null);
                }
              }}
            >
              <div style={ST.modalWide}>
                <button
                  onClick={() => {
                    setUserDetail(null);
                    setUserDetailRegs([]);
                    setUserStats(null);
                  }}
                  style={{
                    position: 'absolute',
                    top: '16px',
                    right: '16px',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    color: '#94a3b8',
                    padding: '6px',
                    borderRadius: '8px',
                  }}
                >
                  <FiX size={20} />
                </button>

                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    marginBottom: '20px',
                  }}
                >
                  <div style={ST.userDot(userDetail.activo)} />
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: '18px', fontWeight: 700, color: 'var(--agx-text)' }}>
                      {userDetail.nombre}
                    </div>
                    <div style={{ fontSize: '13px', color: 'var(--agx-muted)' }}>
                      {userDetail.rol}
                      {userDetail.sede_asignada ? ' | ' + userDetail.sede_asignada : ''}
                    </div>
                    {userDetail.aviso_tipo && (
                      <div style={{ marginTop: '4px' }}>
                        <span
                          style={{
                            fontSize: '11px',
                            fontWeight: 600,
                            color: userDetail.aviso_tipo === 'ausencia' ? '#7c3aed' : '#f59e0b',
                            background:
                              userDetail.aviso_tipo === 'ausencia'
                                ? isDark()
                                  ? '#2d1f6b'
                                  : '#f3e8ff'
                                : isDark()
                                  ? '#78350f'
                                  : '#fffbeb',
                            padding: '2px 8px',
                            borderRadius: '6px',
                          }}
                        >
                          {userDetail.aviso_tipo === 'ausencia'
                            ? 'Aviso: Ausencia hoy'
                            : 'Aviso: Llegada tarde hoy'}
                        </span>
                        {userDetail.aviso_motivo && (
                          <span
                            style={{
                              fontSize: '11px',
                              color: 'var(--agx-muted)',
                              marginLeft: '6px',
                            }}
                          >
                            {userDetail.aviso_motivo}
                          </span>
                        )}
                      </div>
                    )}
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <span style={ST.badge(userDetail.activo ? '#16a34a' : '#94a3b8')}>
                      {userDetail.activo ? 'Activo' : 'Inactivo'}
                    </span>
                    {userDetail.ultima_hora && (
                      <div
                        style={{ fontSize: '11px', color: 'var(--agx-faint)', marginTop: '4px' }}
                      >
                        {userDetail.ultimo_tipo === 'entrada' ? 'Entrada ' : 'Salida '}
                        {formatTime(userDetail.ultima_hora)}
                      </div>
                    )}
                  </div>
                </div>

                {userStats && (
                  <div
                    style={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
                      gap: '10px',
                      marginBottom: '16px',
                    }}
                  >
                    <div
                      style={{
                        background: isDark() ? '#064e3b' : '#f0fdf4',
                        borderRadius: '14px',
                        padding: '14px',
                        textAlign: 'center',
                      }}
                    >
                      <div style={{ fontSize: '22px', fontWeight: 700, color: '#16a34a' }}>
                        {userStats.horas_semana}h
                      </div>
                      <div
                        style={{ fontSize: '11px', color: 'var(--agx-muted)', marginTop: '4px' }}
                      >
                        Esta semana
                      </div>
                    </div>
                    <div
                      style={{
                        background: isDark() ? '#1e3a5f' : '#eff6ff',
                        borderRadius: '14px',
                        padding: '14px',
                        textAlign: 'center',
                      }}
                    >
                      <div style={{ fontSize: '22px', fontWeight: 700, color: ACCENT_BLUE }}>
                        {userStats.horas_mes}h
                      </div>
                      <div
                        style={{ fontSize: '11px', color: 'var(--agx-muted)', marginTop: '4px' }}
                      >
                        Este mes
                      </div>
                    </div>
                    <div
                      style={{
                        background:
                          userStats.alertas_semana > 0
                            ? isDark()
                              ? '#7f1d1d'
                              : '#fef2f2'
                            : 'var(--agx-bg2)',
                        borderRadius: '14px',
                        padding: '14px',
                        textAlign: 'center',
                      }}
                    >
                      <div
                        style={{
                          fontSize: '22px',
                          fontWeight: 700,
                          color: userStats.alertas_semana > 0 ? '#dc2626' : '#16a34a',
                        }}
                      >
                        {userStats.alertas_semana}
                      </div>
                      <div
                        style={{ fontSize: '11px', color: 'var(--agx-muted)', marginTop: '4px' }}
                      >
                        Retrasos semana
                      </div>
                    </div>
                  </div>
                )}

                {userStats?.horario && (
                  <div
                    style={{
                      background: 'var(--agx-bg2)',
                      borderRadius: '14px',
                      padding: '16px',
                      border: '1px solid var(--agx-border)',
                      marginBottom: '16px',
                    }}
                  >
                    <div
                      style={{
                        fontSize: '12px',
                        fontWeight: 700,
                        color: 'var(--agx-muted)',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                        marginBottom: '10px',
                      }}
                    >
                      Horario laboral
                    </div>
                    {userStats.horario.horarios_json ? (
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                        {Object.entries(userStats.horario.horarios_json)
                          .sort(([a], [b]) => parseInt(a) - parseInt(b))
                          .map(([d, val]) => {
                            const dn = {
                              1: 'Lun',
                              2: 'Mar',
                              3: 'Mie',
                              4: 'Jue',
                              5: 'Vie',
                              6: 'Sab',
                              7: 'Dom',
                            };
                            return (
                              <div
                                key={d}
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '10px',
                                  fontSize: '13px',
                                  padding: '4px 0',
                                }}
                              >
                                <span
                                  style={{ fontWeight: 600, color: '#16a34a', minWidth: '32px' }}
                                >
                                  {dn[d]}
                                </span>
                                <span style={{ fontWeight: 500, color: 'var(--agx-text)' }}>
                                  {val.entrada || '--:--'} - {val.salida || '--:--'}
                                </span>
                              </div>
                            );
                          })}
                      </div>
                    ) : (
                      <div style={{ fontSize: '13px', color: 'var(--agx-text)' }}>
                        {userStats.horario.entrada || '--:--'} -{' '}
                        {userStats.horario.salida || '--:--'}
                        {userStats.horario.dias_laborales && (
                          <span
                            style={{
                              fontSize: '11px',
                              color: 'var(--agx-muted)',
                              marginLeft: '8px',
                            }}
                          >
                            (
                            {userStats.horario.dias_laborales
                              .split(',')
                              .map(
                                (d) =>
                                  ({ 1: 'L', 2: 'M', 3: 'X', 4: 'J', 5: 'V', 6: 'S', 7: 'D' })[
                                    d.trim()
                                  ]
                              )
                              .join(',')}
                            )
                          </span>
                        )}
                      </div>
                    )}
                    {userStats.horario.tolerancia != null && (
                      <div
                        style={{ fontSize: '11px', color: 'var(--agx-faint)', marginTop: '6px' }}
                      >
                        Tolerancia: {userStats.horario.tolerancia} min
                      </div>
                    )}
                  </div>
                )}

                {usuarioResumen && (
                  <div
                    style={{
                      background: 'var(--agx-bg2)',
                      borderRadius: '14px',
                      padding: '16px',
                      border: '1px solid var(--agx-border)',
                      marginBottom: '16px',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        marginBottom: '10px',
                      }}
                    >
                      <button
                        onClick={() => navigateUserMonth(-1)}
                        style={{
                          background: 'none',
                          border: 'none',
                          cursor: 'pointer',
                          color: 'var(--agx-muted)',
                          padding: '4px',
                          borderRadius: '6px',
                        }}
                      >
                        <FiChevronLeft size={14} />
                      </button>
                      <div style={{ fontSize: '13px', fontWeight: 700, color: 'var(--agx-text)' }}>
                        Resumen{' '}
                        {
                          [
                            'Ene',
                            'Feb',
                            'Mar',
                            'Abr',
                            'May',
                            'Jun',
                            'Jul',
                            'Ago',
                            'Sep',
                            'Oct',
                            'Nov',
                            'Dic',
                          ][userDetailMonth - 1]
                        }{' '}
                        {userDetailYear}
                      </div>
                      <button
                        onClick={() => navigateUserMonth(1)}
                        style={{
                          background: 'none',
                          border: 'none',
                          cursor: 'pointer',
                          color: 'var(--agx-muted)',
                          padding: '4px',
                          borderRadius: '6px',
                        }}
                      >
                        <FiChevronRight size={14} />
                      </button>
                    </div>
                    <div
                      style={{
                        display: 'grid',
                        gridTemplateColumns: isMobile ? 'repeat(4, 1fr)' : 'repeat(8, 1fr)',
                        gap: '6px',
                      }}
                    >
                      <div
                        style={{
                          textAlign: 'center',
                          background: 'var(--agx-surface)',
                          borderRadius: '8px',
                          padding: '8px 4px',
                          border: '1px solid var(--agx-border)',
                        }}
                      >
                        <div style={{ fontSize: '16px', fontWeight: 700, color: '#16a34a' }}>
                          {usuarioResumen.dias_trabajados}
                        </div>
                        <div
                          style={{ fontSize: '9px', color: 'var(--agx-muted)', marginTop: '1px' }}
                        >
                          Dias
                        </div>
                      </div>
                      <div
                        style={{
                          textAlign: 'center',
                          background: 'var(--agx-surface)',
                          borderRadius: '8px',
                          padding: '8px 4px',
                          border: '1px solid var(--agx-border)',
                        }}
                      >
                        <div style={{ fontSize: '16px', fontWeight: 700, color: ACCENT_BLUE }}>
                          {usuarioResumen.horas_totales}h
                        </div>
                        <div
                          style={{ fontSize: '9px', color: 'var(--agx-muted)', marginTop: '1px' }}
                        >
                          Horas
                        </div>
                      </div>
                      <div
                        style={{
                          textAlign: 'center',
                          background: 'var(--agx-surface)',
                          borderRadius: '8px',
                          padding: '8px 4px',
                          border: '1px solid var(--agx-border)',
                        }}
                      >
                        <div
                          style={{
                            fontSize: '16px',
                            fontWeight: 700,
                            color:
                              usuarioResumen.minutos_extra > 0 ? '#16a34a' : 'var(--agx-muted)',
                          }}
                        >
                          {usuarioResumen.minutos_extra > 0
                            ? '+' + usuarioResumen.minutos_extra
                            : '0'}
                          m
                        </div>
                        <div
                          style={{ fontSize: '9px', color: 'var(--agx-muted)', marginTop: '1px' }}
                        >
                          Extra
                        </div>
                      </div>
                      <div
                        style={{
                          textAlign: 'center',
                          background: 'var(--agx-surface)',
                          borderRadius: '8px',
                          padding: '8px 4px',
                          border: '1px solid var(--agx-border)',
                        }}
                      >
                        <div
                          style={{
                            fontSize: '16px',
                            fontWeight: 700,
                            color: usuarioResumen.minutos_atraso > 0 ? '#dc2626' : '#16a34a',
                          }}
                        >
                          {usuarioResumen.minutos_atraso}m
                        </div>
                        <div
                          style={{ fontSize: '9px', color: 'var(--agx-muted)', marginTop: '1px' }}
                        >
                          Atraso
                        </div>
                      </div>
                      <div
                        style={{
                          textAlign: 'center',
                          background: 'var(--agx-surface)',
                          borderRadius: '8px',
                          padding: '8px 4px',
                          border: '1px solid var(--agx-border)',
                        }}
                      >
                        <div
                          style={{
                            fontSize: '16px',
                            fontWeight: 700,
                            color:
                              usuarioResumen.horas_esperadas > 0
                                ? 'var(--agx-muted)'
                                : 'var(--agx-muted)',
                          }}
                        >
                          {usuarioResumen.horas_esperadas}h
                        </div>
                        <div
                          style={{ fontSize: '9px', color: 'var(--agx-muted)', marginTop: '1px' }}
                        >
                          Esperado
                        </div>
                      </div>
                      <div
                        style={{
                          textAlign: 'center',
                          background: 'var(--agx-surface)',
                          borderRadius: '8px',
                          padding: '8px 4px',
                          border: '1px solid var(--agx-border)',
                        }}
                      >
                        <div style={{ fontSize: '16px', fontWeight: 700, color: '#dc2626' }}>
                          {usuarioResumen.retrasos}
                        </div>
                        <div
                          style={{ fontSize: '9px', color: 'var(--agx-muted)', marginTop: '1px' }}
                        >
                          Retrasos
                        </div>
                      </div>
                      <div
                        style={{
                          textAlign: 'center',
                          background: 'var(--agx-surface)',
                          borderRadius: '8px',
                          padding: '8px 4px',
                          border: '1px solid var(--agx-border)',
                        }}
                      >
                        <div
                          style={{
                            fontSize: '16px',
                            fontWeight: 700,
                            color:
                              usuarioResumen.inasistencias > 0 ? '#dc2626' : 'var(--agx-muted)',
                          }}
                        >
                          {usuarioResumen.inasistencias}
                        </div>
                        <div
                          style={{ fontSize: '9px', color: 'var(--agx-muted)', marginTop: '1px' }}
                        >
                          Inasist.
                        </div>
                      </div>
                      <div
                        style={{
                          textAlign: 'center',
                          background: 'var(--agx-surface)',
                          borderRadius: '8px',
                          padding: '8px 4px',
                          border: '1px solid var(--agx-border)',
                        }}
                      >
                        <div style={{ fontSize: '16px', fontWeight: 700, color: '#7c3aed' }}>
                          {usuarioResumen.avisos_mes}
                        </div>
                        <div
                          style={{ fontSize: '9px', color: 'var(--agx-muted)', marginTop: '1px' }}
                        >
                          Avisos
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div
                  style={{ display: 'flex', gap: '8px', marginBottom: '20px', flexWrap: 'wrap' }}
                >
                  {permGest && (
                    <button onClick={() => setManualOpen(true)} style={ST.btn(BRAND_BLUE)}>
                      <FiUserPlus size={14} /> Registrar Manual
                    </button>
                  )}
                  <button
                    onClick={handleExportarPDFUsuario}
                    disabled={pdfLoadingUsuario}
                    style={{ ...ST.btnOutline, opacity: pdfLoadingUsuario ? 0.6 : 1 }}
                  >
                    <FiFileText size={14} /> {pdfLoadingUsuario ? 'Generando...' : 'Reporte PDF'}
                  </button>
                </div>

                {manualOpen && (
                  <div
                    style={{
                      background: 'var(--agx-bg2)',
                      borderRadius: '14px',
                      padding: '18px',
                      border: '1px solid var(--agx-border)',
                      marginBottom: '16px',
                    }}
                  >
                    <div
                      style={{
                        fontSize: '14px',
                        fontWeight: 600,
                        color: 'var(--agx-text)',
                        marginBottom: '14px',
                      }}
                    >
                      Registro manual - {userDetail.nombre}
                    </div>
                    <div
                      style={{
                        display: 'grid',
                        gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
                        gap: '10px',
                        marginBottom: '10px',
                      }}
                    >
                      <div>
                        <label
                          style={{
                            display: 'block',
                            fontSize: '12px',
                            fontWeight: 600,
                            color: 'var(--agx-muted)',
                            marginBottom: '4px',
                          }}
                        >
                          Tipo
                        </label>
                        <select
                          value={manualTipo}
                          onChange={(e) => setManualTipo(e.target.value)}
                          style={{ ...ST.input, maxWidth: '100%' }}
                        >
                          <option value="entrada">Entrada</option>
                          <option value="salida">Salida</option>
                        </select>
                      </div>
                      <div>
                        <label
                          style={{
                            display: 'block',
                            fontSize: '12px',
                            fontWeight: 600,
                            color: 'var(--agx-muted)',
                            marginBottom: '4px',
                          }}
                        >
                          Sede
                        </label>
                        <input
                          value={manualSede}
                          onChange={(e) => setManualSede(e.target.value)}
                          placeholder="Codigo sede (opcional)"
                          style={{ ...ST.input, maxWidth: '100%' }}
                        />
                      </div>
                    </div>
                    <div style={{ marginBottom: '10px' }}>
                      <label
                        style={{
                          display: 'block',
                          fontSize: '12px',
                          fontWeight: 600,
                          color: 'var(--agx-muted)',
                          marginBottom: '4px',
                        }}
                      >
                        Fecha/Hora (opcional)
                      </label>
                      <input
                        type="datetime-local"
                        value={manualHora}
                        onChange={(e) => setManualHora(e.target.value)}
                        style={{ ...ST.input, maxWidth: '100%' }}
                      />
                    </div>
                    <div style={{ marginBottom: '12px' }}>
                      <label
                        style={{
                          display: 'block',
                          fontSize: '12px',
                          fontWeight: 600,
                          color: 'var(--agx-muted)',
                          marginBottom: '4px',
                        }}
                      >
                        Notas
                      </label>
                      <input
                        value={manualNotas}
                        onChange={(e) => setManualNotas(e.target.value)}
                        placeholder="Motivo del registro manual"
                        style={{ ...ST.input, maxWidth: '100%' }}
                      />
                    </div>
                    <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                      <button onClick={() => setManualOpen(false)} style={ST.btnOutline}>
                        Cancelar
                      </button>
                      <button onClick={handleRegistrarManual} style={ST.btn('#16a34a')}>
                        <FiCheckCircle size={14} /> Registrar
                      </button>
                    </div>
                  </div>
                )}

                <div style={ST.sectionTitle}>Historial de asistencia</div>
                {userDetailRegs.length === 0 && <div style={ST.emptyState}>Sin registros</div>}

                {userDetailRegs.length > 0 && (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '16px' }}>
                    {paresPorDia(userDetailRegs).map((dia) => (
                      <div
                        key={dia.fecha}
                        style={{
                          background: 'var(--agx-bg2)',
                          borderRadius: '12px',
                          padding: '12px 14px',
                          border: '1px solid var(--agx-border)',
                        }}
                      >
                        <div
                          style={{
                            fontSize: '12px',
                            fontWeight: 700,
                            color: 'var(--agx-muted)',
                            marginBottom: '8px',
                            textTransform: 'uppercase',
                            letterSpacing: '0.4px',
                          }}
                        >
                          {dia.fecha}
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                          {dia.pares.map((p, idx) => {
                            const inicio = p.entrada ? new Date(p.entrada.hora_registro) : null;
                            const fin = p.salida ? new Date(p.salida.hora_registro) : null;
                            const totalMs = fin && inicio ? fin - inicio : null;
                            const color = p.entrada?.alerta_tipo
                              ? S_COLORS[p.entrada.alerta_tipo]
                              : '#16a34a';
                            return (
                              <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <div
                                  style={{
                                    flex: 1,
                                    position: 'relative',
                                    height: '10px',
                                    borderRadius: '5px',
                                    background: 'var(--agx-border)',
                                    overflow: 'hidden',
                                  }}
                                >
                                  {inicio && fin && (
                                    <div
                                      style={{
                                        position: 'absolute',
                                        left: '0',
                                        width: '100%',
                                        height: '100%',
                                        background: color,
                                        borderRadius: '5px',
                                      }}
                                    />
                                  )}
                                  {inicio && !fin && (
                                    <div
                                      style={{
                                        position: 'absolute',
                                        left: '0',
                                        width: '100%',
                                        height: '100%',
                                        background: color,
                                        borderRadius: '5px',
                                        opacity: 0.5,
                                      }}
                                    />
                                  )}
                                </div>
                                <span style={{ fontSize: '12px', fontWeight: 600, color: 'var(--agx-text)', minWidth: '88px' }}>
                                  {inicio ? formatTime(inicio.toISOString()) : '--:--'}
                                  {' - '}
                                  {fin ? formatTime(fin.toISOString()) : '--:--'}
                                </span>
                                <span style={{ fontSize: '11px', color: 'var(--agx-muted)', minWidth: '48px', textAlign: 'right' }}>
                                  {totalMs != null ? (totalMs / 3600000).toFixed(1) + 'h' : '-'}
                                </span>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                <table style={ST.table}>
                  <thead>
                    <tr>
                      <th style={ST.th}>Fecha/Hora</th>
                      <th style={ST.th}>Tipo</th>
                      <th style={ST.th}>Sede</th>
                      <th style={ST.th}>Alerta</th>
                      <th style={ST.th}>Notas</th>
                      {permCorregir && <th style={{ ...ST.th, width: '70px' }}>Accion</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {userDetailRegs.map((r, i) => (
                      <tr key={r.id} style={i % 2 === 0 ? ST.trEven : {}}>
                        <td style={ST.td}>{formatFecha(r.hora_registro)}</td>
                        <td style={ST.td}>
                          <span style={ST.badge(S_COLORS[r.tipo])}>
                            {r.tipo === 'entrada' ? 'Entrada' : 'Salida'}
                          </span>
                        </td>
                        <td style={ST.td}>{r.sede_codigo || '-'}</td>
                        <td style={ST.td}>
                          {r.alerta_tipo ? (
                            <span style={ST.alertaBadge(r.alerta_tipo)}>
                              <FiAlertTriangle size={11} />
                              {RETRASO_LABELS[r.alerta_tipo]}
                            </span>
                          ) : (
                            '-'
                          )}
                        </td>
                        <td
                          style={{
                            ...ST.td,
                            maxWidth: '160px',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {r.notas || '-'}
                        </td>
                        {permCorregir && (
                          <td style={ST.td}>
                            <button
                              onClick={() => openEditRegistro(r)}
                              style={{ ...ST.btnOutline, padding: '4px 10px', fontSize: '11px' }}
                            >
                              Editar
                            </button>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      )}

      {/* ── PDF Preview Usuario Modal ── */}
      {pdfUrlUsuario && (
        <div
          style={ST.modal}
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              window.URL.revokeObjectURL(pdfUrlUsuario);
              setPdfUrlUsuario(null);
            }
          }}
        >
          <div
            style={{
              ...ST.modalContent(true),
              maxWidth: '900px',
              height: '90vh',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '12px',
                flexWrap: 'wrap',
                gap: '8px',
              }}
            >
              <div style={{ fontSize: '16px', fontWeight: 700, color: 'var(--agx-text)' }}>
                Reporte {userDetail?.nombre}
              </div>
              <div style={{ display: 'flex', gap: '8px' }}>
                <button
                  onClick={() => {
                    var a = document.createElement('a');
                    a.href = pdfUrlUsuario;
                    a.download =
                      'asistencia_' +
                      (userDetail?.nombre || 'usuario').replace(/\s/g, '_') +
                      '_' +
                      new Date().toISOString().slice(0, 10) +
                      '.pdf';
                    a.click();
                  }}
                  style={ST.btn(ACCENT_BLUE)}
                >
                  <FiDownload size={14} /> Descargar
                </button>
                <button
                  onClick={() => {
                    var w = window.open(pdfUrlUsuario, '_blank');
                    setTimeout(function () {
                      w.print();
                    }, 1000);
                  }}
                  style={ST.btnOutline}
                >
                  Imprimir
                </button>
                <button
                  onClick={() => {
                    window.URL.revokeObjectURL(pdfUrlUsuario);
                    setPdfUrlUsuario(null);
                  }}
                  style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    color: '#94a3b8',
                    padding: '4px',
                  }}
                >
                  <FiX size={20} />
                </button>
              </div>
            </div>
            <iframe
              src={pdfUrlUsuario}
              style={{ flex: 1, border: 'none', borderRadius: '8px' }}
              title="PDF Preview"
            />
          </div>
        </div>
      )}

      {/* ── REGISTROS ── */}
      {tab === 'registros' && (
        <div>
          {/* Filter bar - collapsible on mobile */}
          {isMobile ? (
            <div style={{ marginBottom: '12px' }}>
              <button
                onClick={() => setFiltrosOpen(!filtrosOpen)}
                style={{ ...ST.btnOutline, width: '100%', justifyContent: 'space-between' }}
              >
                <span>Filtros {filtros.fecha_desde ? '(activos)' : ''}</span>
                <FiChevronDown
                  size={14}
                  style={{
                    transform: filtrosOpen ? 'rotate(180deg)' : 'none',
                    transition: 'transform 0.2s',
                  }}
                />
              </button>
              {filtrosOpen && (
                <div
                  style={{
                    marginTop: '10px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px',
                  }}
                >
                  <input
                    type="date"
                    style={{ ...ST.input, maxWidth: '100%' }}
                    value={filtros.fecha_desde}
                    onChange={(e) => setFiltros((f) => ({ ...f, fecha_desde: e.target.value }))}
                  />
                  <input
                    type="date"
                    style={{ ...ST.input, maxWidth: '100%' }}
                    value={filtros.fecha_hasta}
                    onChange={(e) => setFiltros((f) => ({ ...f, fecha_hasta: e.target.value }))}
                  />
                  <label
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px',
                      fontSize: '13px',
                      color: 'var(--agx-muted)',
                      cursor: 'pointer',
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={filtros.solo_alertas}
                      onChange={(e) =>
                        setFiltros((f) => ({ ...f, solo_alertas: e.target.checked }))
                      }
                    />
                    Solo retrasos
                  </label>
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <button
                      onClick={() => {
                        setRegistros([]);
                        setRegUltimo(null);
                        setRegUltimoHora(null);
                        loadRegistros(true);
                      }}
                      style={{ ...ST.btn(ACCENT_BLUE), flex: 1, justifyContent: 'center' }}
                    >
                      <FiSearch size={14} /> Filtrar
                    </button>
                    <button
                      onClick={handleExportarExcel}
                      style={{ ...ST.btnOutline, flex: 1, justifyContent: 'center' }}
                    >
                      <FiDownload size={14} /> Excel
                    </button>
                    {permGest && (
                      <button
                        onClick={openNuevoRegistro}
                        style={{ ...ST.btn(BRAND_BLUE), flex: 1, justifyContent: 'center' }}
                      >
                        <FiUserPlus size={14} /> Nuevo registro
                      </button>
                    )}
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div style={ST.flexRow}>
              <input
                type="date"
                style={ST.input}
                value={filtros.fecha_desde}
                onChange={(e) => setFiltros((f) => ({ ...f, fecha_desde: e.target.value }))}
              />
              <input
                type="date"
                style={ST.input}
                value={filtros.fecha_hasta}
                onChange={(e) => setFiltros((f) => ({ ...f, fecha_hasta: e.target.value }))}
              />
              <label
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  fontSize: '13px',
                  color: 'var(--agx-muted)',
                  cursor: 'pointer',
                }}
              >
                <input
                  type="checkbox"
                  checked={filtros.solo_alertas}
                  onChange={(e) => setFiltros((f) => ({ ...f, solo_alertas: e.target.checked }))}
                />
                Solo retrasos
              </label>
              <select
                value={regFiltroUsuario}
                onChange={(e) => setRegFiltroUsuario(e.target.value)}
                style={{ ...ST.input, maxWidth: '220px' }}
              >
                <option value="">Todos los usuarios</option>
                {usuariosEstado.map((u) => (
                  <option key={u.cedula} value={u.cedula}>
                    {u.nombre}
                  </option>
                ))}
              </select>
              <select
                value={regFiltroSede}
                onChange={(e) => setRegFiltroSede(e.target.value)}
                style={{ ...ST.input, maxWidth: '180px' }}
              >
                <option value="">Todas las sedes</option>
                {sedes
                  .filter((s) => s.activa)
                  .map((s) => (
                    <option key={s.codigo} value={s.codigo}>
                      {s.nombre}
                    </option>
                  ))}
              </select>
              <button
                onClick={() => {
                  setRegistros([]);
                  setRegUltimo(null);
                  setRegUltimoHora(null);
                  loadRegistros(true);
                }}
                style={ST.btnOutline}
              >
                <FiSearch size={14} /> Filtrar
              </button>
              <button onClick={handleExportarExcel} style={ST.btn(ACCENT_BLUE)}>
                <FiDownload size={14} /> Exportar Excel
              </button>
              {permGest && (
                <button onClick={openNuevoRegistro} style={ST.btn(BRAND_BLUE)}>
                  <FiUserPlus size={14} /> Nuevo registro
                </button>
              )}
            </div>
          )}
          {registros.length === 0 && !filtrosOpen ? (
            <div style={ST.card}>
              <div style={ST.emptyState}>No hay registros que coincidan con los filtros</div>
            </div>
          ) : (
            <div style={ST.card}>
              <table style={ST.table}>
                <thead>
                  <tr>
                    <th style={ST.th}>Fecha/Hora</th>
                    <th style={ST.th}>Usuario</th>
                    <th style={ST.th}>Tipo</th>
                    <th style={ST.th}>Sede</th>
                    <th style={ST.th}>Alerta</th>
                    <th style={ST.th}>Notas</th>
                    {(permGest || permCorregir) && (
                      <th style={{ ...ST.th, width: '96px' }}>Accion</th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {registros.map((r, i) => (
                    <tr key={r.id} style={i % 2 === 0 ? ST.trEven : {}}>
                      <td style={ST.td}>{formatFecha(r.hora_registro)}</td>
                      <td style={{ ...ST.td, fontWeight: 500 }}>{r.nombre}</td>
                      <td style={ST.td}>
                        <span style={ST.badge(S_COLORS[r.tipo])}>{r.tipo}</span>
                      </td>
                      <td style={ST.td}>{r.sede_codigo || '-'}</td>
                      <td style={ST.td}>
                        {r.alerta_tipo ? (
                          <span style={ST.alertaBadge(r.alerta_tipo)}>
                            <FiAlertTriangle size={11} />
                            {RETRASO_LABELS[r.alerta_tipo]}
                          </span>
                        ) : (
                          '-'
                        )}
                      </td>
                      <td
                        style={{
                          ...ST.td,
                          maxWidth: '180px',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {r.notas || '-'}
                      </td>
                      {(permGest || permCorregir) && (
                        <td style={ST.td}>
                          <div style={{ display: 'flex', gap: '6px' }}>
                            {permCorregir && (
                              <button
                                onClick={() => openEditRegistro(r)}
                                style={{
                                  ...ST.btnOutline,
                                  padding: '4px 10px',
                                  fontSize: '11px',
                                }}
                              >
                                Editar
                              </button>
                            )}
                            {permGest && (
                              <button
                                onClick={async () => {
                                  if (window.confirm('Eliminar este registro?')) {
                                    try {
                                      await API.delete('/asistencia/registros/' + r.id);
                                      loadRegistros(true);
                                      loadUsuariosEstado();
                                    } catch (e) {}
                                  }
                                }}
                                style={{ ...ST.btnRed, padding: '4px 8px', fontSize: '11px' }}
                              >
                                <FiTrash2 size={11} />
                              </button>
                            )}
                          </div>
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
              {regMore && (
                <div style={{ textAlign: 'center', marginTop: '14px' }}>
                  <button onClick={() => loadRegistros(false)} style={ST.btnOutline}>
                    <FiChevronDown size={14} /> Cargar mas
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      )}

      {/* ── REPORTES ── */}
      {tab === 'reportes' && (
        <div>
          {!reportMonth ? (
            <>
              <div
                style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}
              >
                <button
                  onClick={() => setReportYear(reportYear - 1)}
                  style={{ ...ST.btnOutline, padding: '6px 10px', borderRadius: '10px' }}
                >
                  <FiChevronLeft />
                </button>
                <div
                  style={{
                    fontSize: '22px',
                    fontWeight: 700,
                    color: 'var(--agx-text)',
                    letterSpacing: '-0.3px',
                  }}
                >
                  {reportYear}
                </div>
                <button
                  onClick={() => setReportYear(reportYear + 1)}
                  style={{ ...ST.btnOutline, padding: '6px 10px', borderRadius: '10px' }}
                >
                  <FiChevronRight />
                </button>
              </div>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: isMobile
                    ? 'repeat(auto-fill, minmax(140px, 1fr))'
                    : 'repeat(auto-fill, minmax(220px, 1fr))',
                  gap: '14px',
                }}
              >
                {[
                  'Ene',
                  'Feb',
                  'Mar',
                  'Abr',
                  'May',
                  'Jun',
                  'Jul',
                  'Ago',
                  'Sep',
                  'Oct',
                  'Nov',
                  'Dic',
                ].map((name, i) => {
                  const m = i + 1;
                  const isCurrent =
                    reportYear === new Date().getFullYear() && m === new Date().getMonth() + 1;
                  return (
                    <button
                      key={m}
                      onClick={() => {
                        setReportMonth(m);
                        loadResumenMensual(reportYear, m);
                      }}
                      style={ST.monthCard(isCurrent)}
                    >
                      <div style={{ fontSize: '15px', fontWeight: 700, color: 'var(--agx-text)' }}>
                        {name}
                      </div>
                      <div
                        style={{ fontSize: '12px', color: 'var(--agx-faint)', marginTop: '4px' }}
                      >
                        {reportYear}
                      </div>
                      {isCurrent && (
                        <div
                          style={{
                            marginTop: '6px',
                            padding: '2px 10px',
                            borderRadius: '8px',
                            background: ACCENT_BLUE + '15',
                            color: ACCENT_BLUE,
                            fontSize: '11px',
                            fontWeight: 600,
                            display: 'inline-block',
                          }}
                        >
                          Actual
                        </div>
                      )}
                    </button>
                  );
                })}
              </div>
            </>
          ) : (
            <>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  marginBottom: '16px',
                  flexWrap: 'wrap',
                }}
              >
                <button
                  onClick={() => {
                    setReportMonth(null);
                    setResumenMensual(null);
                    setDetalleDia(null);
                  }}
                  style={{ ...ST.btnOutline, padding: '8px 12px' }}
                >
                  <FiChevronLeft /> Meses
                </button>
                <button
                  onClick={() => {
                    let m2 = reportMonth - 1;
                    let y2 = reportYear;
                    if (m2 < 1) {
                      m2 = 12;
                      y2--;
                    }
                    setReportMonth(m2);
                    setReportYear(y2);
                    setDetalleDia(null);
                    loadResumenMensual(y2, m2);
                  }}
                  style={{ ...ST.btnOutline, padding: '6px 10px', borderRadius: '8px' }}
                >
                  <FiChevronLeft size={14} />
                </button>
                <div
                  style={{
                    fontSize: '18px',
                    fontWeight: 700,
                    color: 'var(--agx-text)',
                    minWidth: '120px',
                    textAlign: 'center',
                  }}
                >
                  {
                    [
                      'Ene',
                      'Feb',
                      'Mar',
                      'Abr',
                      'May',
                      'Jun',
                      'Jul',
                      'Ago',
                      'Sep',
                      'Oct',
                      'Nov',
                      'Dic',
                    ][reportMonth - 1]
                  }{' '}
                  {reportYear}
                </div>
                <button
                  onClick={() => {
                    let m2 = reportMonth + 1;
                    let y2 = reportYear;
                    if (m2 > 12) {
                      m2 = 1;
                      y2++;
                    }
                    setReportMonth(m2);
                    setReportYear(y2);
                    setDetalleDia(null);
                    loadResumenMensual(y2, m2);
                  }}
                  style={{ ...ST.btnOutline, padding: '6px 10px', borderRadius: '8px' }}
                >
                  <FiChevronRight size={14} />
                </button>
                <div style={{ flex: 1 }} />
                {resumenMensual?.dias?.length > 0 && (
                  <button
                    onClick={handleExportPDF}
                    disabled={pdfLoading}
                    style={{ ...ST.btn('#dc2626'), opacity: pdfLoading ? 0.6 : 1 }}
                  >
                    <FiFileText size={14} /> {pdfLoading ? 'Generando...' : 'PDF'}
                  </button>
                )}
              </div>

              {detalleDia && (
                <div
                  style={ST.modal}
                  onClick={(e) => {
                    if (e.target === e.currentTarget) {
                      setDetalleDia(null);
                      setDetalleFecha(null);
                      setDetalleAvisos([]);
                    }
                  }}
                >
                  <div
                    style={{
                      ...ST.modalWide,
                      maxWidth: '700px',
                      padding: isMobile ? '20px' : '28px',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '16px',
                      }}
                    >
                      <div style={{ fontSize: '16px', fontWeight: 700, color: 'var(--agx-text)' }}>
                        {new Date(detalleFecha + 'T12:00:00').toLocaleDateString('es-VE', {
                          weekday: 'long',
                          day: 'numeric',
                          month: 'long',
                        })}
                      </div>
                      <button
                        onClick={() => {
                          setDetalleDia(null);
                          setDetalleFecha(null);
                          setDetalleAvisos([]);
                        }}
                        style={{
                          background: 'none',
                          border: 'none',
                          cursor: 'pointer',
                          color: '#94a3b8',
                          padding: '6px',
                          borderRadius: '8px',
                        }}
                      >
                        <FiX size={20} />
                      </button>
                    </div>

                    {detalleAvisos.length > 0 && (
                      <div
                        style={{
                          background: isDark() ? '#2d1f6b' : '#f3e8ff',
                          borderRadius: '12px',
                          padding: '12px 16px',
                          marginBottom: '16px',
                          border: '1px solid #e9d5ff',
                        }}
                      >
                        <div
                          style={{
                            fontSize: '12px',
                            fontWeight: 700,
                            color: '#7c3aed',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px',
                            marginBottom: '8px',
                          }}
                        >
                          Avisos del dia
                        </div>
                        {detalleAvisos.map((a, ai) => (
                          <div
                            key={ai}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px',
                              fontSize: '13px',
                              padding: '2px 0',
                            }}
                          >
                            <span
                              style={{
                                display: 'inline-block',
                                width: '8px',
                                height: '8px',
                                borderRadius: '50%',
                                background: a.tipo === 'ausencia' ? '#7c3aed' : '#f59e0b',
                                flexShrink: 0,
                              }}
                            />
                            <span style={{ fontWeight: 500, color: 'var(--agx-text)' }}>
                              {a.nombre}
                            </span>
                            <span style={{ fontSize: '11px', color: 'var(--agx-faint)' }}>
                              - {a.tipo === 'ausencia' ? 'Ausencia' : 'Llegada tarde'}
                            </span>
                            {a.motivo && (
                              <span
                                style={{
                                  fontSize: '11px',
                                  color: 'var(--agx-muted)',
                                  fontStyle: 'italic',
                                }}
                              >
                                "{a.motivo}"
                              </span>
                            )}
                          </div>
                        ))}
                      </div>
                    )}

                    {detalleDia.length === 0 && (
                      <div
                        style={{
                          textAlign: 'center',
                          color: 'var(--agx-faint)',
                          fontSize: '13px',
                          padding: '20px',
                        }}
                      >
                        Sin registros para este dia
                      </div>
                    )}
                    {detalleDia.length > 0 && (
                      <div style={{ overflowX: 'auto' }}>
                        <table style={ST.table}>
                          <thead>
                            <tr>
                              <th style={ST.th}>Usuario</th>
                              <th style={ST.th}>Rol</th>
                              <th style={ST.th}>Entrada</th>
                              <th style={ST.th}>Salida</th>
                              <th style={ST.th}>Horas</th>
                              <th style={ST.th}>Notas</th>
                            </tr>
                          </thead>
                          <tbody>
                            {detalleDia.map((r, i) => (
                              <tr key={i} style={i % 2 === 0 ? ST.trEven : {}}>
                                <td style={{ ...ST.td, fontWeight: 500 }}>{r.nombre}</td>
                                <td style={ST.td}>{r.rol}</td>
                                <td style={ST.td}>
                                  {formatTime(r.entrada)}
                                  {r.alerta_entrada && (
                                    <span
                                      style={{
                                        display: 'inline-block',
                                        width: '6px',
                                        height: '6px',
                                        borderRadius: '50%',
                                        background: S_COLORS[r.alerta_entrada] || '#f59e0b',
                                        marginLeft: '4px',
                                        verticalAlign: 'middle',
                                      }}
                                      title={RETRASO_LABELS[r.alerta_entrada]}
                                    />
                                  )}
                                </td>
                                <td style={ST.td}>
                                  {formatTime(r.salida)}
                                  {r.alerta_salida && (
                                    <span
                                      style={{
                                        display: 'inline-block',
                                        width: '6px',
                                        height: '6px',
                                        borderRadius: '50%',
                                        background: S_COLORS[r.alerta_salida] || '#f59e0b',
                                        marginLeft: '4px',
                                        verticalAlign: 'middle',
                                      }}
                                      title={RETRASO_LABELS[r.alerta_salida]}
                                    />
                                  )}
                                </td>
                                <td style={{ ...ST.td, fontWeight: 600 }}>
                                  {r.horas_trabajadas !== null ? r.horas_trabajadas + 'h' : '-'}
                                </td>
                                <td style={{ ...ST.td, maxWidth: '200px', fontSize: '12px' }}>
                                  {r.notas_entrada && (
                                    <div style={{ color: 'var(--agx-muted)' }}>
                                      E: {r.notas_entrada}
                                    </div>
                                  )}
                                  {r.notas_salida && (
                                    <div style={{ color: 'var(--agx-muted)' }}>
                                      S: {r.notas_salida}
                                    </div>
                                  )}
                                  {!r.notas_entrada && !r.notas_salida && '-'}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {resumenMensual && (
                <div
                  style={{ display: 'flex', gap: '10px', marginBottom: '16px', flexWrap: 'wrap' }}
                >
                  <div style={ST.statCard('#16a34a')}>
                    <FiCalendar size={18} color="#16a34a" />
                    <div>
                      <div style={{ fontSize: '18px', fontWeight: 700, color: 'var(--agx-text)' }}>
                        {resumenMensual.dias?.length || 0}
                      </div>
                      <div style={{ fontSize: '10px', color: 'var(--agx-muted)' }}>
                        Dias con actividad
                      </div>
                    </div>
                  </div>
                  <div style={ST.statCard(ACCENT_BLUE)}>
                    <FiUsers size={18} color={ACCENT_BLUE} />
                    <div>
                      <div style={{ fontSize: '18px', fontWeight: 700, color: 'var(--agx-text)' }}>
                        {resumenMensual.total_horas_mes || 0}h
                      </div>
                      <div style={{ fontSize: '10px', color: 'var(--agx-muted)' }}>
                        Horas totales
                      </div>
                    </div>
                  </div>
                  <div style={ST.statCard('#7c3aed')}>
                    <FiAlertTriangle size={18} color="#7c3aed" />
                    <div>
                      <div style={{ fontSize: '18px', fontWeight: 700, color: 'var(--agx-text)' }}>
                        {resumenMensual.dias?.reduce((c, d) => c + (d.avisos?.length || 0), 0) || 0}
                      </div>
                      <div style={{ fontSize: '10px', color: 'var(--agx-muted)' }}>Avisos</div>
                    </div>
                  </div>
                </div>
              )}

              <div style={ST.card}>
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(7, 1fr)',
                    gap: isMobile ? '3px' : '6px',
                  }}
                >
                  {['Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab', 'Dom'].map((d, di) => (
                    <div
                      key={d}
                      style={{
                        textAlign: 'center',
                        fontSize: '10px',
                        fontWeight: 700,
                        color: di >= 5 ? '#ea580c' : 'var(--agx-faint)',
                        padding: '2px 0 8px',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                      }}
                    >
                      {d}
                    </div>
                  ))}
                  {(() => {
                    const firstDay = new Date(reportYear, reportMonth - 1, 1).getDay();
                    const daysInMonth = new Date(reportYear, reportMonth, 0).getDate();
                    const offset = firstDay === 0 ? 6 : firstDay - 1;
                    const diasData = resumenMensual?.dias || [];
                    const diasMap = {};
                    diasData.forEach((d) => {
                      diasMap[d.fecha.slice(8, 10)] = d;
                    });
                    const today = new Date();
                    const todayStr =
                      today.getFullYear() +
                      '-' +
                      String(today.getMonth() + 1).padStart(2, '0') +
                      '-' +
                      String(today.getDate()).padStart(2, '0');
                    const cells = [];
                    for (let i = 0; i < offset; i++) cells.push(<div key={'e' + i} />);
                    for (let d = 1; d <= daysInMonth; d++) {
                      const diaStr = String(d).padStart(2, '0');
                      const fecha =
                        reportYear + '-' + String(reportMonth).padStart(2, '0') + '-' + diaStr;
                      const info = diasMap[diaStr];
                      const avisos = info?.avisos || [];
                      const hasData = !!info && (info.total_usuarios > 0 || avisos.length > 0);
                      const onlyAvisos = !!info && info.total_usuarios === 0 && avisos.length > 0;
                      const isToday = fecha === todayStr;
                      const dow = new Date(reportYear, reportMonth - 1, d).getDay();
                      const isWeekend = dow === 0 || dow === 6;
                      const cellBg = hasData
                        ? onlyAvisos
                          ? isDark()
                            ? '#2d1f6b'
                            : '#f3e8ff'
                          : isDark()
                            ? '#064e3b'
                            : '#f0fdf4'
                        : isWeekend
                          ? '#f5f5f5'
                          : 'var(--agx-surface)';
                      cells.push(
                        <div
                          key={d}
                          onClick={() => (hasData ? loadDetalleDia(fecha) : null)}
                          title={
                            hasData
                              ? info.total_usuarios +
                                ' usuarios · ' +
                                info.total_registros +
                                ' registros' +
                                (avisos.length ? ' · ' + avisos.length + ' avisos' : '')
                              : ''
                          }
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: isMobile ? '5px 1px' : '8px 2px',
                            borderRadius: '10px',
                            border: isToday ? '2px solid ' + ACCENT_BLUE : '1px solid transparent',
                            background: cellBg,
                            cursor: hasData ? 'pointer' : 'default',
                            minHeight: isMobile ? '44px' : '60px',
                            transition: 'all 0.15s',
                          }}
                        >
                          <div
                            style={{
                              fontSize: isMobile ? '13px' : '14px',
                              fontWeight: isToday ? 700 : 500,
                              color: hasData
                                ? 'var(--agx-text)'
                                : isWeekend
                                  ? '#b0b0b0'
                                  : 'var(--agx-faint)',
                              lineHeight: 1.2,
                            }}
                          >
                            {d}
                          </div>
                          {hasData && (
                            <div
                              style={{
                                fontSize: isMobile ? '10px' : '12px',
                                fontWeight: 700,
                                color: onlyAvisos ? '#7c3aed' : '#16a34a',
                                lineHeight: 1.2,
                                marginTop: '1px',
                              }}
                            >
                              {onlyAvisos ? avisos.length : info.total_usuarios}
                            </div>
                          )}
                          {avisos.length > 0 && (
                            <div
                              style={{
                                marginTop: '2px',
                                display: 'flex',
                                gap: '2px',
                                flexWrap: 'wrap',
                                justifyContent: 'center',
                              }}
                            >
                              {avisos.slice(0, 3).map((a, ai) => (
                                <div
                                  key={ai}
                                  style={{
                                    width: '5px',
                                    height: '5px',
                                    borderRadius: '50%',
                                    background: a.tipo === 'ausencia' ? '#7c3aed' : '#f59e0b',
                                  }}
                                  title={
                                    a.nombre +
                                    ': ' +
                                    (a.tipo === 'ausencia' ? 'Ausencia' : 'Llegada tarde') +
                                    (a.motivo ? ' - ' + a.motivo : '')
                                  }
                                />
                              ))}
                              {avisos.length > 3 && (
                                <span
                                  style={{
                                    fontSize: '7px',
                                    color: 'var(--agx-faint)',
                                    lineHeight: '5px',
                                  }}
                                >
                                  +{avisos.length - 3}
                                </span>
                              )}
                            </div>
                          )}
                        </div>
                      );
                    }
                    return cells;
                  })()}
                </div>
                <div
                  style={{
                    display: 'flex',
                    gap: '14px',
                    marginTop: '14px',
                    fontSize: '10px',
                    color: 'var(--agx-muted)',
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                    borderTop: '1px solid var(--agx-border)',
                    paddingTop: '12px',
                  }}
                >
                  <span>
                    <span
                      style={{
                        display: 'inline-block',
                        width: '6px',
                        height: '6px',
                        borderRadius: '50%',
                        background: '#16a34a',
                        marginRight: '4px',
                        verticalAlign: 'middle',
                      }}
                    />
                    Asistencia
                  </span>
                  <span>
                    <span
                      style={{
                        display: 'inline-block',
                        width: '6px',
                        height: '6px',
                        borderRadius: '50%',
                        background: '#7c3aed',
                        marginRight: '4px',
                        verticalAlign: 'middle',
                      }}
                    />
                    Ausencia
                  </span>
                  <span>
                    <span
                      style={{
                        display: 'inline-block',
                        width: '6px',
                        height: '6px',
                        borderRadius: '50%',
                        background: '#f59e0b',
                        marginRight: '4px',
                        verticalAlign: 'middle',
                      }}
                    />
                    Llegada tarde
                  </span>
                  <span style={{ color: '#ccc' }}>|</span>
                  <span style={{ color: '#b0b0b0' }}>Fin de semana</span>
                </div>
              </div>
            </>
          )}
        </div>
      )}

      {/* ── PDF Preview Modal ── */}
      {pdfUrl && (
        <div
          style={ST.modal}
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              window.URL.revokeObjectURL(pdfUrl);
              setPdfUrl(null);
            }
          }}
        >
          <div
            style={{
              ...ST.modalContent(true),
              maxWidth: '900px',
              height: '90vh',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '12px',
                flexWrap: 'wrap',
                gap: '8px',
              }}
            >
              <div style={{ fontSize: '16px', fontWeight: 700, color: 'var(--agx-text)' }}>
                Reporte{' '}
                {
                  [
                    'Ene',
                    'Feb',
                    'Mar',
                    'Abr',
                    'May',
                    'Jun',
                    'Jul',
                    'Ago',
                    'Sep',
                    'Oct',
                    'Nov',
                    'Dic',
                  ][reportMonth - 1]
                }{' '}
                {reportYear}
              </div>
              <div style={{ display: 'flex', gap: '8px' }}>
                <button
                  onClick={() => {
                    var a = document.createElement('a');
                    a.href = pdfUrl;
                    a.download =
                      'asistencia_' +
                      reportYear +
                      '_' +
                      String(reportMonth).padStart(2, '0') +
                      '.pdf';
                    a.click();
                  }}
                  style={ST.btn(ACCENT_BLUE)}
                >
                  <FiDownload size={14} /> Descargar
                </button>
                <button
                  onClick={() => {
                    var w = window.open(pdfUrl, '_blank');
                    setTimeout(function () {
                      w.print();
                    }, 1000);
                  }}
                  style={ST.btnOutline}
                >
                  Imprimir
                </button>
                <button
                  onClick={() => {
                    window.URL.revokeObjectURL(pdfUrl);
                    setPdfUrl(null);
                  }}
                  style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    color: '#94a3b8',
                    padding: '4px',
                  }}
                >
                  <FiX size={20} />
                </button>
              </div>
            </div>
            <iframe
              src={pdfUrl}
              style={{ flex: 1, border: 'none', borderRadius: '8px' }}
              title="PDF Preview"
            />
          </div>
        </div>
      )}

      {/* ── HORARIOS ── */}
      {tab === 'horarios' && (
        <div>
          <div style={ST.flexRow}>
            <button
              onClick={() => {
                setSchedEdit({});
                setSchedOpen(true);
              }}
              style={ST.btn(BRAND_BLUE)}
            >
              <FiCalendar size={14} /> Agregar Horario
            </button>
          </div>
          <div style={ST.card}>
            {horarios.length === 0 && <div style={ST.emptyState}>No hay horarios configurados</div>}
            {horarios.length > 0 && (
              <table style={ST.table}>
                <thead>
                  <tr>
                    <th style={ST.th}>Usuario</th>
                    <th style={ST.th}>Rol</th>
                    <th style={ST.th}>Entrada</th>
                    <th style={ST.th}>Salida</th>
                    <th style={ST.th}>Tolerancia</th>
                    <th style={ST.th}>Dias</th>
                    <th style={ST.th}>Estado</th>
                    <th style={ST.th}>Accion</th>
                  </tr>
                </thead>
                <tbody>
                  {horarios.map((h, i) => (
                    <tr key={h.id} style={i % 2 === 0 ? ST.trEven : {}}>
                      <td style={{ ...ST.td, fontWeight: 500 }}>{h.nombre}</td>
                      <td style={ST.td}>{h.rol}</td>
                      <td style={ST.td}>{h.hora_entrada_esperada || '-'}</td>
                      <td style={ST.td}>{h.hora_salida_esperada || '-'}</td>
                      <td style={ST.td}>{h.tolerancia_min} min</td>
                      <td style={ST.td}>{h.dias_laborales}</td>
                      <td style={ST.td}>
                        <span style={ST.badge(h.activo ? '#16a34a' : '#94a3b8')}>
                          {h.activo ? 'Activo' : 'Inactivo'}
                        </span>
                      </td>
                      <td style={ST.td}>
                        <div style={{ display: 'flex', gap: '6px' }}>
                          <button
                            onClick={() => {
                              setSchedEdit(h);
                              setSchedOpen(true);
                            }}
                            style={{ ...ST.btnOutline, padding: '5px 12px', fontSize: '12px' }}
                          >
                            Editar
                          </button>
                          <button
                            onClick={async () => {
                              if (window.confirm('Eliminar horario?')) {
                                try {
                                  await API.delete('/asistencia/horarios/' + h.usuario_cedula);
                                  loadHorarios();
                                } catch (e) {}
                              }
                            }}
                            style={{ ...ST.btnRed, padding: '5px 12px', fontSize: '12px' }}
                          >
                            <FiTrash2 size={12} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
          {schedOpen && (
            <ScheduleModal
              isMobile={isMobile}
              initial={schedEdit}
              onClose={() => {
                setSchedOpen(false);
                setSchedEdit(null);
              }}
              onSaved={() => {
                setSchedOpen(false);
                setSchedEdit(null);
                loadHorarios();
              }}
            />
          )}
        </div>
      )}

      {/* ── QRs GENERADOS ── */}
      {tab === 'qrs' && (
        <div>
          <div style={{ ...ST.flexRow, justifyContent: 'space-between' }}>
            <button onClick={handleOpenQRGen} style={ST.btn(BRAND_BLUE)}>
              <FiMaximize size={14} /> Generar QR
            </button>
            <button onClick={loadQrsPorSede} style={ST.btnOutline}>
              <FiRefreshCw size={14} /> Actualizar
            </button>
          </div>

          <div style={ST.card}>
            {qrLoading && <div style={ST.emptyState}>Cargando QRs...</div>}
            {!qrLoading && qrAll.length === 0 && (
              <div style={ST.emptyState}>No hay QRs generados. Genera uno para comenzar.</div>
            )}
            {!qrLoading && qrAll.length > 0 && (
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fill, minmax(260px, 1fr))',
                  gap: '20px',
                }}
              >
                {qrAll.map((q) => (
                  <div key={q.sede_codigo} style={ST.qrCard}>
                    <div style={{ width: '100%' }}>
                      <div
                        style={{
                          fontSize: '15px',
                          fontWeight: 700,
                          color: 'var(--agx-text)',
                          marginBottom: '2px',
                        }}
                      >
                        {q.sede_nombre}
                      </div>
                      <div style={{ fontSize: '12px', color: 'var(--agx-muted)', fontWeight: 500 }}>
                        {q.sede_codigo}
                      </div>
                    </div>
                    {qrImageMap[q.sede_codigo] ? (
                      <div
                        style={{
                          background: 'var(--agx-bg2)',
                          padding: '14px',
                          borderRadius: '14px',
                          border: '1px solid var(--agx-border)',
                        }}
                      >
                        <img
                          src={qrImageMap[q.sede_codigo]}
                          alt={'QR ' + q.sede_nombre}
                          style={{
                            width: '180px',
                            height: '180px',
                            borderRadius: '10px',
                            display: 'block',
                          }}
                        />
                      </div>
                    ) : (
                      <div
                        style={{
                          width: '180px',
                          height: '180px',
                          borderRadius: '10px',
                          border: '1.5px dashed var(--agx-skeleton)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: 'var(--agx-faint)',
                          fontSize: '12px',
                          background: 'var(--agx-bg2)',
                        }}
                      >
                        Cargando QR...
                      </div>
                    )}
                    {qrImageMap[q.sede_codigo] && (
                      <div style={{ display: 'flex', gap: '6px', width: '100%' }}>
                        <button
                          onClick={() => {
                            const a = document.createElement('a');
                            a.href = qrImageMap[q.sede_codigo];
                            a.download = 'QR_Asistencia_' + q.sede_codigo + '.png';
                            a.click();
                          }}
                          style={{
                            ...ST.btnOutline,
                            flex: 1,
                            justifyContent: 'center',
                            padding: '6px 10px',
                            fontSize: '11px',
                          }}
                        >
                          <FiDownload size={12} /> Descargar
                        </button>
                        <button
                          onClick={() => {
                            const win = window.open('', '_blank');
                            win.document.write(
                              '<html><head><title>QR Asistencia - ' +
                                q.sede_nombre +
                                '</title><style>body{display:flex;align-items:center;justify-content:center;height:100vh;margin:0;font-family:sans-serif}<div style="text-align:center;padding:32px"><h2 style="margin-bottom:8px">Asistencia - ' +
                                q.sede_nombre +
                                '</h2><p style="color:#666;font-size:13px">Sede: ' +
                                q.sede_codigo +
                                '</p><img src="' +
                                qrImageMap[q.sede_codigo] +
                                '" width="280" alt="QR" /><p style="margin-top:12px;font-size:11px;color:#999">Escanea para registrar entrada/salida</p></div></body></html>'
                            );
                            win.document.close();
                            setTimeout(function () {
                              win.print();
                            }, 500);
                          }}
                          style={{
                            ...ST.btnOutline,
                            flex: 1,
                            justifyContent: 'center',
                            padding: '6px 10px',
                            fontSize: '11px',
                          }}
                        >
                          Imprimir
                        </button>
                      </div>
                    )}
                    <div style={{ display: 'flex', gap: '8px', width: '100%' }}>
                      <button
                        onClick={() => {
                          navigator.clipboard.writeText(
                            empresaUrl(localStorage.getItem('agorax_empresa_slug') || '') +
                              '/asistencia?token=' +
                              q.token
                          );
                          setQrCopyToken(q.token);
                          setTimeout(() => setQrCopyToken(null), 2000);
                        }}
                        style={{
                          ...ST.btnOutline,
                          flex: 1,
                          justifyContent: 'center',
                          padding: '7px 12px',
                          fontSize: '12px',
                        }}
                      >
                        {qrCopyToken === q.token ? 'Copiado' : 'Copiar URL'}
                      </button>
                      <button
                        onClick={() => setQrRegenConfirm(q.sede_codigo)}
                        style={{ ...ST.btnRed, padding: '7px 14px', fontSize: '12px' }}
                      >
                        <FiTrash2 size={12} /> Regenerar
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {qrRegenConfirm && (
            <div
              style={ST.modal}
              onClick={(e) => {
                if (e.target === e.currentTarget) setQrRegenConfirm(null);
              }}
            >
              <div style={ST.modalContent()}>
                <div style={{ textAlign: 'center', marginBottom: '12px' }}>
                  <FiAlertTriangle size={32} color="#dc2626" style={{ marginBottom: '8px' }} />
                  <div style={{ fontSize: '18px', fontWeight: 700, color: '#dc2626' }}>
                    Regenerar QR
                  </div>
                </div>
                <div
                  style={{
                    fontSize: '14px',
                    color: 'var(--agx-muted)',
                    marginBottom: '20px',
                    lineHeight: 1.6,
                    textAlign: 'center',
                  }}
                >
                  Al regenerar el QR de{' '}
                  <strong>
                    {sedes.find((s) => s.codigo === qrRegenConfirm)?.nombre || qrRegenConfirm}
                  </strong>
                  , el código actual{' '}
                  <strong style={{ color: '#dc2626' }}>dejará de funcionar</strong> inmediatamente.
                  Los usuarios deberan escanear el nuevo QR.
                </div>
                <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                  <button onClick={() => setQrRegenConfirm(null)} style={ST.btnOutline}>
                    Cancelar
                  </button>
                  <button
                    onClick={() => handleRegenerarQr(qrRegenConfirm)}
                    style={ST.btn('#dc2626')}
                  >
                    Regenerar
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {/* ── Modal corregir registro ── */}
      {editRegistro && (
        <div
          style={ST.modal}
          onClick={(e) => {
            if (e.target === e.currentTarget) setEditRegistro(null);
          }}
        >
          <div style={ST.modalContent()}>
            <button
              onClick={() => setEditRegistro(null)}
              style={{
                position: 'absolute',
                top: '16px',
                right: '16px',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                color: '#94a3b8',
                padding: '6px',
                borderRadius: '8px',
              }}
            >
              <FiX size={20} />
            </button>
            <div
              style={{
                fontSize: '18px',
                fontWeight: 700,
                color: 'var(--agx-text)',
                marginBottom: '6px',
              }}
            >
              Corregir registro
            </div>
            <div
              style={{
                fontSize: '13px',
                color: 'var(--agx-muted)',
                marginBottom: '16px',
              }}
            >
              Ajusta la entrada o salida del usuario.
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
              <div>
                <label
                  style={{
                    display: 'block',
                    fontSize: '12px',
                    fontWeight: 600,
                    color: 'var(--agx-muted)',
                    marginBottom: '4px',
                  }}
                >
                  Tipo
                </label>
                <select
                  value={editTipo}
                  onChange={(e) => setEditTipo(e.target.value)}
                  style={{ ...ST.input, maxWidth: '100%' }}
                >
                  <option value="entrada">Entrada</option>
                  <option value="salida">Salida</option>
                </select>
              </div>
              <div>
                <label
                  style={{
                    display: 'block',
                    fontSize: '12px',
                    fontWeight: 600,
                    color: 'var(--agx-muted)',
                    marginBottom: '4px',
                  }}
                >
                  Fecha/Hora
                </label>
                <input
                  type="datetime-local"
                  value={editHora}
                  onChange={(e) => setEditHora(e.target.value)}
                  style={{ ...ST.input, maxWidth: '100%' }}
                />
              </div>
              <div>
                <label
                  style={{
                    display: 'block',
                    fontSize: '12px',
                    fontWeight: 600,
                    color: 'var(--agx-muted)',
                    marginBottom: '4px',
                  }}
                >
                  Sede
                </label>
                <input
                  value={editSede}
                  onChange={(e) => setEditSede(e.target.value)}
                  placeholder="Codigo sede (opcional)"
                  style={{ ...ST.input, maxWidth: '100%' }}
                />
              </div>
              <div>
                <label
                  style={{
                    display: 'block',
                    fontSize: '12px',
                    fontWeight: 600,
                    color: 'var(--agx-muted)',
                    marginBottom: '4px',
                  }}
                >
                  Notas
                </label>
                <input
                  value={editNotas}
                  onChange={(e) => setEditNotas(e.target.value)}
                  placeholder="Observacion"
                  style={{ ...ST.input, maxWidth: '100%' }}
                />
              </div>
              <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                <button onClick={() => setEditRegistro(null)} style={ST.btnOutline}>
                  Cancelar
                </button>
                <button
                  onClick={handleCorregirRegistro}
                  disabled={editSaving || !editHora}
                  style={{ ...ST.btn(ACCENT_BLUE), opacity: editSaving || !editHora ? 0.6 : 1 }}
                >
                  {editSaving ? 'Guardando...' : 'Guardar'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ── Modal nuevo registro ── */}
      {nuevoOpen && (
        <div
          style={ST.modal}
          onClick={(e) => {
            if (e.target === e.currentTarget) setNuevoOpen(false);
          }}
        >
          <div style={ST.modalContent(true)}>
            <button
              onClick={() => setNuevoOpen(false)}
              style={{
                position: 'absolute',
                top: '16px',
                right: '16px',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                color: '#94a3b8',
                padding: '6px',
                borderRadius: '8px',
              }}
            >
              <FiX size={20} />
            </button>
            <div
              style={{
                fontSize: '18px',
                fontWeight: 700,
                color: 'var(--agx-text)',
                marginBottom: '6px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <FiUserPlus size={18} color={ACCENT_BLUE} /> Nuevo registro de asistencia
            </div>
            <div
              style={{
                fontSize: '13px',
                color: 'var(--agx-muted)',
                marginBottom: '16px',
              }}
            >
              Registra una entrada o salida de forma manual.
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
              <div>
                <label
                  style={{
                    display: 'block',
                    fontSize: '12px',
                    fontWeight: 600,
                    color: 'var(--agx-muted)',
                    marginBottom: '4px',
                  }}
                >
                  Usuario
                </label>
                <select
                  value={nuevoUsuario}
                  onChange={(e) => setNuevoUsuario(e.target.value)}
                  style={{ ...ST.input, maxWidth: '100%' }}
                >
                  <option value="">Selecciona un usuario...</option>
                  {usuariosEstado.map((u) => (
                    <option key={u.cedula} value={u.cedula}>
                      {u.nombre} ({u.rol})
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label
                  style={{
                    display: 'block',
                    fontSize: '12px',
                    fontWeight: 600,
                    color: 'var(--agx-muted)',
                    marginBottom: '4px',
                  }}
                >
                  Tipo
                </label>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <button
                    onClick={() => setNuevoTipo('entrada')}
                    style={{
                      flex: 1,
                      padding: '12px 16px',
                      borderRadius: '12px',
                      border: nuevoTipo === 'entrada' ? '2px solid #16a34a' : '1.5px solid var(--agx-border)',
                      background: nuevoTipo === 'entrada' ? (isDark() ? '#064e3b' : '#f0fdf4') : 'var(--agx-surface)',
                      cursor: 'pointer',
                      fontFamily: 'inherit',
                      fontSize: '14px',
                      fontWeight: 600,
                      color: nuevoTipo === 'entrada' ? '#16a34a' : 'var(--agx-muted)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px',
                      transition: 'all 0.15s',
                    }}
                  >
                    <FiUserCheck size={16} /> Entrada
                  </button>
                  <button
                    onClick={() => setNuevoTipo('salida')}
                    style={{
                      flex: 1,
                      padding: '12px 16px',
                      borderRadius: '12px',
                      border: nuevoTipo === 'salida' ? '2px solid #dc2626' : '1.5px solid var(--agx-border)',
                      background: nuevoTipo === 'salida' ? (isDark() ? '#7f1d1d' : '#fef2f2') : 'var(--agx-surface)',
                      cursor: 'pointer',
                      fontFamily: 'inherit',
                      fontSize: '14px',
                      fontWeight: 600,
                      color: nuevoTipo === 'salida' ? '#dc2626' : 'var(--agx-muted)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px',
                      transition: 'all 0.15s',
                    }}
                  >
                    <FiUserX size={16} /> Salida
                  </button>
                </div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '12px' }}>
                <div>
                  <label
                    style={{
                      display: 'block',
                      fontSize: '12px',
                      fontWeight: 600,
                      color: 'var(--agx-muted)',
                      marginBottom: '4px',
                    }}
                  >
                    Fecha/Hora
                  </label>
                  <input
                    type="datetime-local"
                    value={nuevoHora}
                    onChange={(e) => setNuevoHora(e.target.value)}
                    style={{ ...ST.input, maxWidth: '100%' }}
                  />
                </div>
                <div>
                  <label
                    style={{
                      display: 'block',
                      fontSize: '12px',
                      fontWeight: 600,
                      color: 'var(--agx-muted)',
                      marginBottom: '4px',
                    }}
                  >
                    Sede (opcional)
                  </label>
                  <select
                    value={nuevoSede}
                    onChange={(e) => setNuevoSede(e.target.value)}
                    style={{ ...ST.input, maxWidth: '100%' }}
                  >
                    <option value="">Sin sede</option>
                    {sedes
                      .filter((s) => s.activa)
                      .map((s) => (
                        <option key={s.codigo} value={s.codigo}>
                          {s.nombre}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              <div>
                <label
                  style={{
                    display: 'block',
                    fontSize: '12px',
                    fontWeight: 600,
                    color: 'var(--agx-muted)',
                    marginBottom: '4px',
                  }}
                >
                  Notas (opcional)
                </label>
                <input
                  value={nuevoNotas}
                  onChange={(e) => setNuevoNotas(e.target.value)}
                  placeholder="Motivo del registro manual"
                  style={{ ...ST.input, maxWidth: '100%' }}
                />
              </div>

              <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                <button onClick={() => setNuevoOpen(false)} style={ST.btnOutline}>
                  Cancelar
                </button>
                <button
                  onClick={handleCrearRegistro}
                  disabled={nuevoSaving || !nuevoUsuario}
                  style={{
                    ...ST.btn(BRAND_BLUE),
                    opacity: nuevoSaving || !nuevoUsuario ? 0.6 : 1,
                  }}
                >
                  <FiCheckCircle size={14} /> {nuevoSaving ? 'Guardando...' : 'Registrar'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function ScheduleModal({ initial, onClose, onSaved, isMobile }) {
  const DIAS_NOMBRES = { 1: 'Lun', 2: 'Mar', 3: 'Mie', 4: 'Jue', 5: 'Vie', 6: 'Sab', 7: 'Dom' };
  const DIAS_KEYS = ['1', '2', '3', '4', '5', '6', '7'];
  const defaultHorarios = () => {
    const o = {};
    DIAS_KEYS.forEach((k) => {
      o[k] = { entrada: '08:00', salida: '17:00' };
    });
    return o;
  };

  const parseInitial = () => {
    if (initial?.horarios_json && typeof initial.horarios_json === 'object')
      return initial.horarios_json;
    if (
      initial?.dias_laborales &&
      (initial.hora_entrada_esperada || initial.hora_salida_esperada)
    ) {
      const o = {};
      const diasArr = initial.dias_laborales.split(',').map((d) => d.trim());
      DIAS_KEYS.forEach((k) => {
        if (diasArr.includes(k))
          o[k] = {
            entrada: initial.hora_entrada_esperada || '08:00',
            salida: initial.hora_salida_esperada || '17:00',
          };
      });
      return o;
    }
    return initial?.horarios_json || defaultHorarios();
  };

  const isEditing = !!initial?.id;
  const [selectedCedulas, setSelectedCedulas] = useState(
    initial?.usuario_cedula ? [initial.usuario_cedula] : []
  );
  const [userFilter, setUserFilter] = useState('');
  const [horarios, setHorarios] = useState(parseInitial);
  const [tolerancia, setTolerancia] = useState(initial?.tolerancia_min ?? 15);
  const [activo, setActivo] = useState(initial?.activo ?? true);
  const [usuarios, setUsuarios] = useState([]);
  const [error, setError] = useState(null);
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    API.get('/usuarios/listar')
      .then((r) => {
        if (r.data.status === 'success') setUsuarios(r.data.data);
      })
      .catch(() => {});
  }, []);

  const toggleUser = (ced) => {
    if (isEditing) return;
    if (selectedCedulas.includes(ced)) {
      setSelectedCedulas(selectedCedulas.filter((c) => c !== ced));
    } else {
      setSelectedCedulas([...selectedCedulas, ced]);
    }
  };

  const toggleDia = (d) => {
    const h = { ...horarios };
    if (h[d]) {
      delete h[d];
    } else {
      h[d] = { entrada: '08:00', salida: '17:00' };
    }
    setHorarios(h);
  };

  const updateHora = (d, campo, valor) => {
    if (!horarios[d]) return;
    setHorarios({ ...horarios, [d]: { ...horarios[d], [campo]: valor } });
  };

  const handleSave = async () => {
    if (selectedCedulas.length === 0) {
      setError('Selecciona al menos un usuario');
      return;
    }
    setGuardando(true);
    setError(null);
    const diasArr = Object.keys(horarios).sort();
    try {
      if (isEditing || selectedCedulas.length === 1) {
        await API.post('/asistencia/horarios', null, {
          params: {
            usuario_cedula: selectedCedulas[0].trim(),
            tolerancia_min: tolerancia,
            activo,
            dias_laborales: diasArr.join(','),
            horarios_json: JSON.stringify(horarios),
          },
        });
      } else {
        const res = await API.post('/asistencia/horarios/batch', {
          usuarios_cedula: selectedCedulas,
          tolerancia_min: tolerancia,
          activo,
          dias_laborales: diasArr.join(','),
          horarios_json: JSON.stringify(horarios),
        });
        if (res.data.data?.errores?.length > 0) {
          setError(res.data.data.errores.map((e) => e.cedula + ': ' + e.error).join('; '));
          setGuardando(false);
          return;
        }
      }
      onSaved();
    } catch (e) {
      setError(e.response?.data?.detail || 'Error al guardar horario');
    }
    setGuardando(false);
  };

  const filteredUsuarios = usuarios.filter(
    (u) =>
      !userFilter ||
      u.nombre.toLowerCase().includes(userFilter.toLowerCase()) ||
      u.cedula.toLowerCase().includes(userFilter.toLowerCase())
  );

  const ST = {
    modal: {
      position: 'fixed',
      inset: 0,
      background: 'rgba(0,0,0,0.45)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      padding: '20px',
    },
    modalContent: {
      background: 'var(--agx-surface)',
      borderRadius: '24px',
      padding: isMobile ? '20px' : '32px',
      width: '100%',
      maxWidth: '560px',
      maxHeight: '90vh',
      overflow: 'auto',
      boxShadow: '0 25px 80px rgba(0,0,0,0.18)',
    },
    section: {
      background: 'var(--agx-bg2)',
      borderRadius: '14px',
      padding: '16px',
      border: '1px solid var(--agx-border)',
    },
    label: {
      display: 'block',
      fontSize: '12px',
      fontWeight: 700,
      color: 'var(--agx-muted)',
      marginBottom: '6px',
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
    },
    input: {
      padding: '10px 14px',
      borderRadius: '10px',
      border: '1.5px solid var(--agx-skeleton)',
      fontSize: '14px',
      fontFamily: 'inherit',
      width: '100%',
      boxSizing: 'border-box',
      background: 'var(--agx-surface)',
      transition: 'border-color 0.15s',
    },
    btnPrimary: {
      padding: '10px 22px',
      borderRadius: '12px',
      border: 'none',
      fontSize: '14px',
      fontWeight: 600,
      cursor: 'pointer',
      fontFamily: 'inherit',
      background: ACCENT_BLUE,
      color: 'var(--agx-surface)',
      transition: 'all 0.15s',
    },
    btnSecondary: {
      padding: '10px 22px',
      borderRadius: '12px',
      border: '1.5px solid var(--agx-skeleton)',
      fontSize: '14px',
      fontWeight: 600,
      cursor: 'pointer',
      fontFamily: 'inherit',
      background: 'var(--agx-surface)',
      color: 'var(--agx-muted)',
      transition: 'all 0.15s',
    },
    diaPill: (on) => ({
      width: '100%',
      padding: '10px 0',
      borderRadius: '10px',
      border: on ? '2px solid #16a34a' : '1px solid var(--agx-border)',
      background: on ? (isDark() ? '#064e3b' : '#f0fdf4') : 'var(--agx-surface)',
      cursor: 'pointer',
      textAlign: 'center',
      fontFamily: 'inherit',
      fontSize: '12px',
      fontWeight: on ? 700 : 500,
      color: on ? '#16a34a' : 'var(--agx-faint)',
      transition: 'all 0.15s',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '4px',
    }),
    timeInput: {
      width: '100%',
      padding: '6px 4px',
      borderRadius: '6px',
      border: '1px solid var(--agx-skeleton)',
      fontSize: '12px',
      fontFamily: 'inherit',
      textAlign: 'center',
      boxSizing: 'border-box',
      background: 'var(--agx-surface)',
    },
  };

  return (
    <div
      style={ST.modal}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div style={ST.modalContent}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: '24px',
          }}
        >
          <div>
            <div
              style={{
                fontSize: '20px',
                fontWeight: 700,
                color: 'var(--agx-text)',
                letterSpacing: '-0.2px',
              }}
            >
              {isEditing ? 'Editar horario' : 'Nuevo horario'}
            </div>
            {!isEditing && selectedCedulas.length > 0 && (
              <div
                style={{ fontSize: '13px', color: ACCENT_BLUE, marginTop: '2px', fontWeight: 500 }}
              >
                {selectedCedulas.length} usuario(s) seleccionado(s)
              </div>
            )}
          </div>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              color: '#94a3b8',
              padding: '8px',
              borderRadius: '10px',
            }}
          >
            <FiX size={20} />
          </button>
        </div>

        {/* Usuarios */}
        {!isEditing && (
          <div style={{ ...ST.section, marginBottom: '16px' }}>
            <div style={ST.label}>Usuarios</div>
            <div style={{ position: 'relative', marginBottom: '8px' }}>
              <FiSearch
                size={14}
                color="#9ca3af"
                style={{
                  position: 'absolute',
                  left: '12px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  pointerEvents: 'none',
                }}
              />
              <input
                placeholder="Buscar..."
                value={userFilter}
                onChange={(e) => setUserFilter(e.target.value)}
                style={{ ...ST.input, paddingLeft: '36px', fontSize: '13px' }}
              />
            </div>
            <div
              style={{
                maxHeight: '150px',
                overflow: 'auto',
                borderRadius: '10px',
                border: '1px solid var(--agx-border)',
              }}
            >
              {filteredUsuarios.length === 0 && (
                <div
                  style={{
                    padding: '16px',
                    color: 'var(--agx-faint)',
                    fontSize: '12px',
                    textAlign: 'center',
                  }}
                >
                  Sin resultados
                </div>
              )}
              {filteredUsuarios.map((u) => {
                const sel = selectedCedulas.includes(u.cedula);
                return (
                  <div
                    key={u.cedula}
                    onClick={() => toggleUser(u.cedula)}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                      padding: '9px 12px',
                      cursor: 'pointer',
                      borderBottom: '1px solid var(--agx-skeleton)',
                      background: sel ? (isDark() ? '#1e3a5f' : '#eff6ff') : 'var(--agx-surface)',
                      fontSize: '13px',
                      transition: 'background 0.1s',
                    }}
                  >
                    <div
                      style={{
                        width: '18px',
                        height: '18px',
                        borderRadius: '5px',
                        border: sel ? '2px solid ' + ACCENT_BLUE : '2px solid #d1d5db',
                        background: sel ? ACCENT_BLUE : 'var(--agx-surface)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                        transition: 'all 0.15s',
                      }}
                    >
                      {sel && <FiCheckCircle size={12} color="#fff" style={{ marginTop: '1px' }} />}
                    </div>
                    <span style={{ fontWeight: 500, color: 'var(--agx-text)', flex: 1 }}>
                      {u.nombre}
                    </span>
                    <span style={{ color: 'var(--agx-faint)', fontSize: '11px' }}>{u.cedula}</span>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {isEditing && (
          <div style={ST.section}>
            <div style={ST.label}>Usuario</div>
            <div style={{ fontSize: '14px', fontWeight: 600, color: 'var(--agx-text)' }}>
              {usuarios.find((u) => u.cedula === selectedCedulas[0])?.nombre ||
                initial?.usuario_cedula}
            </div>
          </div>
        )}

        {/* Configuracion */}
        <div style={{ ...ST.section, marginTop: '10px', marginBottom: '16px' }}>
          <div
            style={{
              display: 'flex',
              gap: isMobile ? '12px' : '20px',
              alignItems: 'flex-start',
              flexWrap: 'wrap',
            }}
          >
            <div>
              <div style={ST.label}>Tolerancia</div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                <input
                  type="number"
                  min="0"
                  max="120"
                  value={tolerancia}
                  onChange={(e) => setTolerancia(parseInt(e.target.value) || 0)}
                  style={{
                    ...ST.input,
                    width: '72px',
                    fontSize: '14px',
                    padding: '8px 10px',
                    textAlign: 'center',
                  }}
                />
                <span style={{ fontSize: '12px', color: 'var(--agx-muted)' }}>min</span>
              </div>
            </div>
            <div style={{ paddingTop: '22px' }}>
              <label
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  fontSize: '13px',
                  fontWeight: 500,
                  color: 'var(--agx-muted)',
                  cursor: 'pointer',
                }}
              >
                <input
                  type="checkbox"
                  checked={activo}
                  onChange={(e) => setActivo(e.target.checked)}
                  style={{ accentColor: '#16a34a', width: '16px', height: '16px' }}
                />
                Activo
              </label>
            </div>
          </div>
        </div>

        {/* Dias */}
        <div style={ST.section}>
          <div style={ST.label}>Dias laborales</div>
          <div
            style={{
              display: 'flex',
              gap: '4px',
              justifyContent: 'space-between',
              marginBottom: '10px',
            }}
          >
            {DIAS_KEYS.map((d) => {
              const on = !!horarios[d];
              return (
                <button
                  key={d}
                  onClick={() => toggleDia(d)}
                  style={{
                    flex: 1,
                    padding: '8px 0',
                    borderRadius: '8px',
                    border: on ? '1.5px solid #16a34a' : '1px solid var(--agx-border)',
                    background: on ? (isDark() ? '#064e3b' : '#f0fdf4') : 'var(--agx-surface)',
                    cursor: 'pointer',
                    fontFamily: 'inherit',
                    fontSize: '11px',
                    fontWeight: on ? 700 : 400,
                    color: on ? '#16a34a' : 'var(--agx-faint)',
                    transition: 'all 0.12s',
                  }}
                >
                  {isMobile ? d : DIAS_NOMBRES[d]}
                </button>
              );
            })}
          </div>
          {Object.keys(horarios).length > 0 && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
              {DIAS_KEYS.map((d) => {
                if (!horarios[d]) return null;
                return (
                  <div
                    key={d}
                    style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '12px' }}
                  >
                    <span style={{ fontWeight: 600, color: '#16a34a', minWidth: '28px' }}>
                      {DIAS_NOMBRES[d]}
                    </span>
                    <input
                      type="time"
                      value={horarios[d].entrada || '08:00'}
                      onChange={(e) => updateHora(d, 'entrada', e.target.value)}
                      style={{
                        padding: '5px 8px',
                        borderRadius: '6px',
                        border: '1.5px solid var(--agx-skeleton)',
                        fontSize: '12px',
                        fontFamily: 'inherit',
                        width: '90px',
                      }}
                    />
                    <span style={{ color: 'var(--agx-faint)' }}>a</span>
                    <input
                      type="time"
                      value={horarios[d].salida || '17:00'}
                      onChange={(e) => updateHora(d, 'salida', e.target.value)}
                      style={{
                        padding: '5px 8px',
                        borderRadius: '6px',
                        border: '1.5px solid var(--agx-skeleton)',
                        fontSize: '12px',
                        fontFamily: 'inherit',
                        width: '90px',
                      }}
                    />
                  </div>
                );
              })}
            </div>
          )}
        </div>

        {error && (
          <div
            style={{
              marginTop: '14px',
              background: isDark() ? '#7f1d1d' : '#fef2f2',
              color: '#dc2626',
              borderRadius: '10px',
              padding: '12px 14px',
              fontSize: '13px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
            }}
          >
            <FiAlertTriangle size={14} color="#dc2626" /> {error}
          </div>
        )}

        <div
          style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '24px' }}
        >
          <button onClick={onClose} style={ST.btnSecondary}>
            Cancelar
          </button>
          <button
            onClick={handleSave}
            disabled={guardando}
            style={{ ...ST.btnPrimary, opacity: guardando ? 0.6 : 1, minWidth: '100px' }}
          >
            {guardando ? 'Guardando...' : 'Guardar'}
          </button>
        </div>
      </div>
    </div>
  );
}
